const frameworkTranslations = {
  en: {
    translation: {
      TurkeyPhoneNumberValidation:
        'The Turkey phone number must be 11 digits and start with 05.',
      uploadFileWithTouch: 'Touch to upload file',
      AfghanPhoneNumberValidation:
        'The Afghanistan Phone number must be 10 digits and start with 0',
      'Drop Your Desired File Here': 'Drop Your Desired File Here',
      Or: 'Or',
      Choose: 'Choose',
      UseWebcam: 'Use the webcam (CTRL+k)',
      uploaderInputLabelMaximumSize: 'The maximum file size should be 3 MB',
      And: 'And',
      FileUploaderInputLabelFormat:
        'its format should be xls, xlsx, pdf, png, jpg, jpeg, doc, docx, webp.',
      TakePicture: 'Take picture',
      CustomerBasicInformation: 'Customer Basic Information',
      "Please enter the customer's full name. This step is required":
        "Please enter the customer's full name. This step is required",
      'Advanced Details': 'Advanced details',
      'You can optionally enter additional customer information here. This step is not mandatory':
        'You can optionally enter additional customer information here. This step is not mandatory.',
      'Phone Number': 'Phone Number',
      "First, enter the country code, then enter the customer's phone number without the leading zero":
        "First, enter the country code, then enter the customer's phone number without the leading zero",
      MaknakUsername: 'Maknak user name',
      Maknak: 'Maknak',
      "The Maknak username is used to activate the customer's mobile app.":
        "The Maknak username is used to activate the customer's mobile app.",
      'customer account': 'customer account',
      "This step is the most important part of the customer account. Here, you register the customer's remaining balance.":
        "This step is the most important part of the customer account. Here, you register the customer's remaining balance.",
      'tutorial.dateFeature': 'Date Feature',
      'tutorial.dateFeatureContent':
        'This feature allows you to change the transaction date',
      'tutorial.accountStatus': 'Account Status',
      'tutorial.accountStatusContent':
        'In this section you can view the status of the selected account.',
      'tutorial.selectGroup': 'Select Group',
      'tutorial.selectGroupContent':
        'In this section you can select the relevant group for each transaction.',
      'tutorial.description': 'Description',
      'tutorial.descriptionContent':
        'In this section you can enter the description related to the transaction.',
      Back: 'Back',
      'voiceRecorder.stopRecording': 'Stop Recording',
      'voiceRecorder.recording': 'Recording...',
      'voiceRecorder.delete': 'Delete',
      'Important Notice': 'Important Notice',
      'I Understand': 'I Understand',
      'System Account': 'System Account',
      'Operation Type': 'Operation type',
      Comma: ',',
      'Account Title': 'Account Title',
      'Account Number': 'Account Number',
      'Credit Limit': 'Credit limit',
      UncertainCreditLimit:
        'If the credit limit is not specified, the credit limit is considered zero',
      Unlimited: 'Unlimited',
      Add: 'Add',
      HasAccountInitialBalance: 'Does the account have an initial balance?',
      'No Option Message': 'No options',
      'Upload a logo for the header': 'Upload logo for the header',
      HeaderUploaderTitle:
        'The length and width of the header image must be the same',
      ViewHeader: 'View header',
      'Transaction Type': 'Transaction Type',
      AllBranches: 'All branches',
      DepartmentsList: 'Branches List',
      Group: 'Group',
      All: 'All',
      Groups: 'Groups',
      AllCashDesks: 'All cash desks',
      Weak: 'Weak',
      Medium: 'Medium',
      Good: 'Good',
      Excellent: 'Excellent',
      AllOptions: 'All',
      'Communication Way': 'Communication Way',
      Cancel: 'Cancel',
      AllCurrencies: 'All currencies',
      currency: 'Currency',
      Account: 'Account',
      Bank: 'Bank',
      'Bank Information': 'Bank Information',
      Clear: 'Clear',
      OK: 'OK',
      Delete: 'Delete',
      Description: 'Description',
      'Document Type': 'Document type',
      AllEmployees: 'All employees',
      'no attachments': 'no attachments',
      'File size exceeds limit':
        'File size {{fileName}} exceeds the allowed limit.',
      'File with name already exists':
        'File with name {{fileName}} already exists',
      'Connected With Data': 'Connected With Data',
      'Connected Without Data': 'Connected Without Data',
      'Retry (Application Is Not Running)':
        'Retry (Application Is Not Running)',
      Gender: 'Gender',
      Colon: ':',
      Deposit: 'Deposit',
      Withdraw: 'Withdraw',
      'In progress': 'In progress',
      'No Content Message': 'No content',
      NotActiveSystemError: 'The system is not active for you!',
      ExpiredSubscriptionError: 'Your subscription has expired!',
      SubscriptionTimeUntilDate: 'Your subscription time until date',
      HasBeen: 'has been',
      ReActiveAccountTitle:
        'Click on the "Buy version" button to reactive the system',
      ConnectedBranches: 'Connected branches',
      BuyVersion: 'Buy Version',
      buyVersionTitle: 'To use the Ariyana system, first purchase a version.',
      BalanceAmount: 'Balance amount',
      Debtor: 'Debtor',
      Creditor: 'Creditor',
      SyncBalanceAndCreditLimit: 'Sync the balance with credit limit',
      Inventory: 'Inventory',
      Percent: 'Percent',
      '0to50ValidPercentage': 'The percentage must be between 0 and 50',
      'form.organization': 'Organization',
      Dollar: 'Dollar',
      Equal: 'Equal',
      DollarRate: 'Dollar rate',
      CalculationType: 'Calculation type',
      Division: 'Division',
      Multiplication: 'multiplication',
      Prepayments: 'Prepayments',
      AdvancePurchaseContracts: 'Advance Purchase Contracts',
      Assets: 'Assets',
      TangibleAssets: 'Tangible assets',
      ReductionInTangibleAssets: 'Reduction in Depreciation of Tangible Assets',
      IntangibleAssets: 'Intangible Assets',
      DepreciationOfIntangibleAssets: 'Depreciation of Intangible Assets',
      PayableBills: 'Payable bills',
      PayableTaxes: 'Payable Taxes',
      AdvanceSalesContracts: 'Advance Sales Contracts',
      AdministrativeExpenses: 'Administrative expenses',
      TelephoneAndCommunicationExpenses: 'Telephone and Communication Expenses',
      RentExpenses: 'Rent Expenses',
      Insurance: 'Insurance',
      Partners: 'Partners',
      LicensingExpenses: 'Licensing Expenses',
      EmployeeSalaries: 'Employee Salaries',
      ClaimsOnCentralBank: 'Claims on Central Bank',
      SelectRowAlert: 'First select a row.',
      'Due to the long number of letters of the selected document information, it is not possible to share.':
        'Due to the long number of letters of the selected document information, it is not possible to share.',
      Manual: 'Manual',
      'Document Prime': 'Document',
      IssuingOrganization: 'Issuing organization',
      Show: 'Show',
      'Currency Type': 'Currency',
      'From Date': 'From Date',
      TimeZone: 'Time zone',
      'Click to log out of WhatsApp': 'Click to log out of WhatsApp',
      'Click to log in to WhatsApp': 'Click to log in to WhatsApp',
      LogOutConfirmation:
        'Are you sure you want to log out of your WhatsApp account?',
      'Log Out': 'Log Out',
      Return: 'Return',
      PreventZoomModalTitle: 'To change the font size, use the box below.',
      FontSize: 'Font size',
      large: 'Large',
      medium: 'Medium',
      small: 'Small',
      Submit: 'Submit',
      IncomingDraft: 'Incoming Draft',
      OutgoingDraft: 'Outgoing Draft',
      'Draft Number': 'Draft Number',
      'Other Number': 'Other Number',
      Sender: 'Sender',
      Receiver: 'Receiver',
      'Draft Amount': 'Draft amount',
      Commission: 'Commission',
      'Payment Place': 'Payment Place',
      Exchange: 'Exchange',
      Draft: 'Draft',
      'Transaction Description': 'Transaction description',
      RemainingAccount: 'Remaining account',
      Status: 'Status',
      BranchAddress: 'Branch address',
      BranchPhone: 'Branch phone number',
      'Cash withdrawal': 'Cash withdrawal',
      'Cash deposit': 'Cash deposit',
      To: 'To',
      From: 'From',
      Balance: 'Balance',
      'Trade Currency': 'Trade currency',
      Seller: 'Seller',
      'Sell Amount': 'Sell Amount',
      Buyer: 'Buyer',
      'Buy Amount': 'Buy Amount',
      Rate: 'Rate',
      BankWithdraw: 'Bank withdraw',
      BankDeposit: 'Bank deposit',
      'Bank Name': 'Bank Name',
      amount: 'Amount',
      'transfer between accounts': 'Transfer between accounts',
      'Transaction Amount': 'Transaction amount',
      'Account Remaining': 'Account remaining',
      Date: 'Date',
      'Customer Name': 'Customer name',
      AmountAccountWhatsappReport:
        'It is hereby confirmed that the balance of your account is as follows:',
      BranchName: 'Branch name',
      Remaining: 'Remaining',
      New: 'New',
      'Under Review': 'Under review',
      Failed: 'Failed',
      Done: 'Done',
      'transactionType.buy': 'Buy',
      'transactionType.sell': 'Sell',
      Received: 'Received',
      Paid: 'Paid',
      to: 'to',
      'Account Balance': 'Account balance',
      'Sample Balance': '5,435,000',
      'Sample Balance Currency': 'Tomans',
      dir: 'ltr',
      'Your Credit': 'Your Credit',
      Languages: 'Languages',
      Messages: 'Messages',
      'Mirror Branch': 'Mirror Branch',
      Notifications: 'Notifications',
      'Quick Access': 'Quick access',
      Pages: 'Pages',
      'System Settings': 'System Settings',
      UserAccountSystem: 'User account system',
      AccountingSystem: 'Accounting system',
      CurrencyAuction: 'Currency auction',
      SanctionList: 'Sanction list',
      'Central analysis of trades and financial reports':
        'Central analysis of trades and financial reports',
      'Exchange license validation': 'Exchange license validation',
      'Organization Chart': 'Organization chart',
      ExitFromSystem: 'Exit from system',
      'newFeatures.title': 'New Features',
      'newFeatures.excelExport': 'Export All Data as Excel File',
      'newFeatures.excelExportDescription':
        'You can now download all your information as an Excel file from the reports section and the Excel output page.',
      'newFeatures.excelCustomerRegistration':
        'Customer Registration with Excel File',
      'newFeatures.excelCustomerRegistrationDescription':
        'Users can now upload their Excel file containing a list of multiple customers in the customer list section and the data entry section to register several customers simultaneously and add them to their customer list.',
      'newFeatures.priceToText': 'Convert and Display Entered Price to Text',
      'newFeatures.priceToTextDescription':
        'You can select your unknown remittance recipient from among the recipients or manually specify the recipient person in the remittance execution page.',
      'newFeatures.ticketShortcuts': 'Ticket Registration Shortcuts',
      'newFeatures.ticketShortcutsDescription':
        'Currently, when registering a ticket, you can go to the next line using Shift+Enter while typing and register your ticket with Enter.',
      SystemNewFeatures: 'System new features',
      Close: 'Close',
      Next: 'Next',
      'Add Ticket': 'Add Ticket',
      SubmitBugReportSuccessfully:
        'Bug report successfully submitted and will be answered as soon as possible.',
      TicketTitle: 'Ticket title',
      GetScreenShout: 'Get screen shot',
      AddFile: 'Add file if necessary.',
      OrderDetails: 'Order Details',
      'Mobile Number': 'Phone number',
      Operator: 'Operator',
      package: 'package',
      'Select or enter Charge amount': 'Enter or select the recharge amount',
      chargeAmount: 'Charge Amount',
      Accept: 'Accept',
      Continue: 'Continue',
      'Date And Time': 'Date and time',
      PaymentAmount: 'Payment Amount',
      trackingNumber: 'tracking number',
      orderStatusMessage:
        'Your order has been placed and will be processed shortly. You can track its status in the Transactions tab.',
      'Visit Transactions': 'Visit Transactions',
      InProgress: 'In progress',
      BePatient: 'Be patient',
      'No Submited Transaction': 'No Submitted Transaction',
      PubgId: 'PUBG ID',
      LikeeId: 'Likee ID',
      SelectDesirePackage: 'Choose your desired package',
      MaknakApp: 'Maknak application',
      'buy charge': 'buy charge',
      'buy internet': 'Buy Internet',
      buySnap: 'Buy Snap',
      barghararCharge: 'Bargharar Charge',
      Bargharar: 'Bargharar',
      'Bargharar Services': 'Bargharar Services',
      'Buy Package': 'Buy Package',
      'Wallet Charge': 'Wallet Charge',
      'Check Number Exists': 'Check Number Exists',
      'User does not exist': 'User does not exist',
      Amount: 'Amount',
      imoCharge: 'Imo Charge',
      pubgCharge: 'PUBG Charge',
      Services: 'Services',
      Transactions: 'Transactions',
      SelectAccountTitle: 'Please first select your desired account',
      Links: 'Links',
      Moneyx: 'Moneyx',
      Credit: 'credit',
      night: 'Night',
      day: 'Day',
      'Sign Out': 'Sign Out',
      Update: 'Update',
      'New Version Available Phrase':
        'A new version of the system is available, please refresh the page',
      'Sample Person': 'Moein Rabti',
      ErrorPage: 'Error page',
      'utils.accountCode': 'Account Code',
      'utils.name': 'Name',
      'utils.lastName': 'Last Name',
      'utils.phoneNumber': 'Phone Number',
      'utils.countryCode': 'Country Code',
      'utils.inputAmount': 'Input Amount',
      'utils.currencyNotIncluded':
        'Currency "{{currencyCode}}" in row {{rowNumber}} is not included in your currencies',
      'utils.debtorCreditor': 'Debtor/Creditor',
      'utils.gender': 'Gender',
      'utils.firstRowEmpty': 'The first row cannot be empty',
      'utils.lastRowNotFound': 'Last row not found',
      'utils.rowsWithSameAccountDifferentName':
        'Rows with account number {{accountTitle}} cannot have different values in name.',
      'utils.rowsWithSameAccountDifferentLastName':
        'Rows with account number {{accountTitle}} cannot have different values in last name.',
      'utils.rowsWithSameAccountDifferentFatherName':
        'Rows with account number {{accountTitle}} cannot have different values in father name.',
      'utils.rowsWithSameAccountDifferentPhone':
        'Rows with account number {{accountTitle}} cannot have different values in phone number.',
      'utils.rowsWithSameAccountSameCurrency':
        'Rows with account number {{accountTitle}} cannot have the same values in currency code.',
      'utils.rowsWithSameAccountDifferentCountry':
        'Rows with account number {{accountTitle}} cannot have different values in country code.',
      'utils.rowsWithSameAccountDifferentGender':
        'Rows with account number {{accountTitle}} cannot have different values in gender.',
      'utils.rowsWithSameAccountDifferentGroup':
        'Rows with account number {{accountTitle}} cannot have different values in group.',
      'utils.rowsWithSameAccountDifferentCategory':
        'Rows with account number {{accountTitle}} cannot have different values in category.',
      'utils.differentAccountsSamePhone':
        'Rows with different account numbers {{account1}} and {{account2}} cannot have the same phone number',
      'utils.currencyAmountDebtorCreditorRequired':
        'In each row, currency-amount-creditor/debtor must either all be filled or all be empty.',
      'utils.phoneCountryCodeRequired':
        'In each row, phone number and country code must either all be filled or all be empty.',
      'utils.invalidValueInRow':
        'Value "{{cellError}}" in row "{{rowNumber}}" for column "{{columnValue}}" is an unacceptable value.',
      'utils.accountCannotHaveDifferentValues':
        'Account code {{accountNumber}} cannot have different values in {{columnTitle}}',
      'table.calculate': 'Calculate {{column}}',
      'table.column': 'Column',
      'table.rowCount': 'Row Count',
      'table.minimum': 'Minimum',
      'table.maximum': 'Maximum',
      'table.sum': 'Sum',
      'table.average': 'Average',
      CalculationBalance: 'The balance is calculating',
      Known: 'Known',
      Unknown: 'Unknown',
      'bankTransaction.selectBankFirst': 'Please select the bank first.',
      SelectDocument: 'Select document',
      TransactionBeWithoutDescription: 'Transaction be without description',
      SyncCreditLimit: 'Sync credit limit',
      PublishTransactionInWhatsapp:
        'Default transaction notification',
      'Trade Rate': 'Trade Rate',
      positiveTradeRate: 'Trade rate must be greater than zero',
      invalidTradeRate: 'Trade rate is not valid',
      TheWayOfTransaction: 'How should the transaction be done?',
      BaseOnAmount: 'Based on amount',
      BaseOnRate: 'Based on rate',
      SelectItemToAutoCalculate:
        'Which item should be calculated automatically?',
      'triplex.sellAmount': 'Sell Amount',
      'triplex.buyAmount': 'Buy Amount',
      'triplex.conversionRate': 'Conversion Rate',
      'Calculating Profit and Loss': 'Calculating Profit and Loss',
      'System Rate': 'System Rate',
      bankStatusMessage2: 'Balance will be shown after selecting the bank.',
      BankAccountBalance: 'The balance of bank account',
      Deposit2: 'Deposit',
      Withdraw2: 'Withdraw',
      'bankTransaction.document': 'Document {{transactionType}}',
      PaymentType: 'Payment type',
      'bankTransaction.oldTransaction': '{{transactionType}} Old',
      'bankTransaction.transactionDate': 'Transaction Date',
      'Transaction Number': 'Transaction number',
      Branch: 'Branch',
      Settings: 'Settings',
      'creditAccount.balance': 'Credit Account Balance',
      AccountStatusMessage:
        'Balance will be shown after selecting the account.',
      CustomerAccountRemaining: 'Customer account remaining',
      'draggableList.paymentPlace': 'Payment Place',
      Edit: 'Edit',
      'draggableList.delete': 'Delete',
      AddPaymentPlace: 'Add payment place',
      Enable: 'Enable',
      Webcam: 'Webcam',
      'Upload File': 'Upload file',
      NoBalanceIsThere: 'No balance has been submitted.',
      'previewImages.viewDocuments': 'View Documents',
      'providerService.selectOrganizationFirst':
        'After selecting the organization, the organization account balance will be displayed separately.',
      'providerService.organizationBalance': 'Organization Account Balance',
      Search: 'Search',
      ShowLess: 'Show less',
      ShowMore: 'Show more',
      'switchableWhatsapp.noNotification':
        'Transaction is not notified in WhatsApp',
      'updateNotification.systemUpdate':
        'The system will be updated on {{date}} from {{startTime}} to {{endTime}}.',
      'Activating WhatsApp': 'Activating whatsApp',
      WhitsappTitle:
        'Receiving information from WhatsApp. This process might take some time.',
      ConnectionTitle: 'Scan the code below to connect.',
      ScanQrTitle:
        'After scanning the QR Code, do not log out Ariana from connected devices.',
      ScanQrAlert:
        'The process of scanning and connecting to WhatsApp is done only once and applies to all transactions.',
      'freeSolo.senderName': 'Sender Full Name',
      'freeSolo.paymentPlace': 'Payment Place',
      'Fingerprint registered successfully':
        'Fingerprint registered successfully',
      RepeatOperation: 'Repeat Operation',
      'Accept And Register': 'Accept And Register',
      UseDesktopVersionTitle:
        'To activate this possibility, use the desktop version of the software',
      TransferBetweenTwoAccounts: 'Transfer Between Accounts',
      CashTransaction: 'Cash Transaction',
      Miscellaneous: 'Miscellaneous',
      BuySellCurrency: 'Trade Currency',
      BankTransaction: 'Bank Transaction',
      ExecuteDraft: 'Execute Draft',
      Cheque: 'Cheque',
      InterBankTransaction: 'Inter Bank Transaction',
      PaymentOrderReceipt: 'Payment Order Receipt',
      ChangeBranch: 'Change Rate',
      UnknownBankTransaction: 'Unknown Bank Transaction',
      AddNewAccount: 'Add new account',
      UpdateAccount: 'Update Account',
      DeleteAccount: 'Delete Account',
      AddBank: 'Add Bank',
      UpdateBank: 'Update Bank',
      DeleteBank: 'Delete Bank',
      AddCustomer: 'Add Customer',
      UpdateCustomer: 'Update Customer',
      DeleteCustomer: 'Delete Customer',
      AddCompany: 'Add Company',
      UpdateCompany: 'Update Company',
      DeleteCompany: 'Delete Company',
      AddBranch: 'Add Branch',
      UpdateBranch: 'Update Branch',
      DeleteBranch: 'Delete Branch',
      AddCurrency: 'Add Currency',
      UpdateCurrency: 'Update Currency',
      DeleteCurrency: 'Delete Currency',
      AddPayOrder: 'Add Pay Order',
      UpdatePayOrder: 'Update Pay Order',
      DeletePayOrder: 'Delete Pay Order',
      Checkout: 'Checkout',
      RemoveCheckout: 'Remove Checkout',
      PendDraft: 'Pending Draft',
      RemovePendDraft: 'Remove Pending Draft',
      IncreaseCredit: 'Increase Credit',
      CancelDraft: 'Cancel Draft',
      SavedToCustomerAccount: 'Saved to Customer Account',
      HasReturned: 'Has Returned',
      CashedToMoney: 'Cashed to Money',
      SavedToCashDeskOrBankAccount: 'Saved to Cash Desk or Bank Account',
      Normal: 'Normal',
      Telegram: 'Telegram',
      Whatsapp: 'WhatsApp',
      Other: 'Other',
      Male: 'Male',
      Female: 'Female',
      customer: 'Customer',
      receiver: 'Receiver',
      Passport: 'Passport',
      'Physical Tezkire': 'Physical Tezkire',
      'Electronic Tezkire': 'Electronic Tezkire',
      'National Card': 'National Card',
      'Birth Certificate': 'Birth Certificate',
      'Kimlik Card': 'Kimlik Card',
      'Driving License': 'Driving License',
      Germany: 'Germany',
      Sweden: 'Sweden',
      Norway: 'Norway',
      Greece: 'Greece',
      Baghdad: 'Baghdad',
      Ankara: 'Ankara',
      'Saudi Arabia': 'Saudi Arabia',
      Tehran: 'Tehran',
      'United Arab Emirates': 'United Arab Emirates',
      Kabul: 'Kabul',
      'Islamabad, Karachi': 'Islamabad, Karachi',
      Australia: 'Australia',
      China: 'China',
      'Moneyx Accounting Panel': 'Moneyx Accounting Panel',
      Accounts: 'Accounts',
      'Archived Accounts': 'Archived Accounts',
      'Journal Entries': 'Journal Entries',
      'Bank Transaction': 'Bank Transaction',
      'Banks List': 'Banks List',
      Dashboard: 'Dashboard',
      Department: 'Department',
      'General Ledger': 'General Ledger',
      'Branch Edition': 'Branch Edition',
      'Branch Registration': 'Branch Registration',
      'Branches List': 'Branches List',
      'Cash Transaction': 'Cash Transaction',
      'Cheques List': 'Cheques List',
      Reports: 'Reports',
      Registration: 'Registration',
      'Commissions Report': 'Commissions Report',
      'Edit Company': 'Edit Company',
      'Company Registration': 'Company Registration',
      'Currencies Management': 'Currencies Management',
      'Customers List': 'Customers List',
      profile: 'Profile',
      'System Management': 'System Management',
      'Operation of the day': 'Operation of the day',
      'Operation Of The Day': 'Operation Of The Day',
      'Debtor And Creditor List': 'Debtor And Creditor List',
      'Decrease Customer Credit': 'Decrease Customer Credit',
      Drafts: 'Drafts',
      'Draft Conduction': 'Draft Conduction',
      'Incoming Draft Submission': 'Incoming Draft Submission',
      'Miscellaneous Draft Submission': 'Miscellaneous Draft Order',
      'Outgoing Draft Submission': 'Outgoing Draft Submission',
      'Draft Documents List': 'Draft Documents List',
      'Unrealized Drafts List': 'Unrealized Drafts List',
      'Draft Orders List': 'Draft Orders List',
      'Excel Data Output': 'Excel Data Output',
      'Financial Operation': 'Financial Operation',
      'Increase Customer Credit': 'Increase Customer Credit',
      'Interbank Transaction': 'Interbank Transaction',
      'Organizations List': 'Organizations List',
      'Payment Order': 'Payment Order',
      'Pending Transactions List': 'Pending Transactions List',
      'Edit Person': 'Edit Person',
      'Register Person': 'Register Person',
      'Profit And Loss Statement': 'Profit And Loss Statement',
      'Receivers List': 'Receivers List',
      'Bug Details': 'Bug Details',
      'Reported Bugs': 'Reported Bugs',
      'System Accounts': 'System Accounts',
      'System Guides': 'System Guides',
      'Trade Currencies List': 'Trade Currencies List',
      'Transfer Between Accounts': 'Transfer Between Accounts',
      'Unknown Bank Transactions': 'Unknown Bank Transactions',
      'Bank Book': 'Bank Book',
      'Branch Account': 'Branch Account',
      'Customer Credit Account': 'Customer Credit Account',
      'My Tickets': 'My Tickets',
      'Pending Drafts List': 'Pending Drafts List',
      English: 'English',
      'language.persian': 'Persian',
      'Accounting Panel': 'Accounting Panel',
      Administrator: 'Administrator',
      'Submit Cash Transaction': 'Submit Cash Transaction',
      'Submit Bank Transaction': 'Submit Bank Transaction',
      'Credits Account': 'Credits Account',
      'Draft Submission': 'Draft Submission',
      'Draft List': 'Draft List',
      Outgoing: 'Outgoing',
      Incoming: 'Incoming',
      'Buy Currency': 'Buy Currency',
      'Sell Currency': 'Sell Currency',
      'Account Information': 'Account information',
      actionArchive: 'Archive',
      Archived: 'Archived',
      AddAccount: 'Add Account',
      unknownbankaccounts: 'unknown bank accounts',
      End: 'End',
      'Mirror Branch Account': 'Mirror branch account',
      MirrorBranchAccount: 'Mirror branch account',
      UnexecutedDraft: 'Unrealized drafts',
      unexecuteddraft: 'Unrealized drafts',
      'Mirror Branch Information': 'Mirror Branch Account Information',
      'Required field message': 'Filling this field is necessary',
      undestandAndDoNotShowAgain:
        'I have read the above, do not show it again.',
      Buy: 'Buy',
      'invalid number': 'Invalid phoneNumber',
      'PhoneNumber must be 11 digits and start with 0':
        'Iran phoneNumber must be 11 digits and start with 09',
      noteCreatedSuccessfully: 'Note Created Successfully',
      DeleteNoteTitle: 'Are you sure you want to delete this note?',
      noteEditedSuccessfully: 'Note Edited Successfully.',
      Notes: 'Notes',
      select: 'Select',
      PersonProfile: 'Person profile',
      'Bank Transactions': 'Bank Transactions List',
      General: 'General',
      Banking: 'Banking',
      Cost: 'Cost'
    },
    dir: 'ltr'
  },
  fa: {
    translation: {
      TurkeyPhoneNumberValidation:
        'شماره تلفن ترکیه باید ۱۱ رقم باشد و با 05 شروع شود.',
      AfghanPhoneNumberValidation:
        'شماره تلفن افغانستان باید ۱۰ رقمی باشد و با ۰۷ شروع شود',
      'invalid number': 'شماره تلفن نامعتبر است.',
      'PhoneNumber must be 11 digits and start with 0':
        'شماره تلفن ایران باید ۱۱ رقمی باشد و با ۰۹ شروع شود',
      uploadFileWithTouch: 'برای آپلود فایل، لمس کنید',
      'Drop Your Desired File Here': 'فایل مورد نظر را اینجا رها کنید',
      Or: 'یا',
      Choose: 'انتخاب کنید',
      UseWebcam: 'از وبکم استفاده کنید (CTRL + k)',
      uploaderInputLabelMaximumSize: 'حجم فایل حداکثر باید ۳مگابایت باشد',
      And: 'و',
      FileUploaderInputLabelFormat:
        'فرمت آن باید xls, xlsx, pdf, png, jpg, jpeg, doc, docx, webp باشد.',
      TakePicture: 'گرفتن عکس',
      CustomerBasicInformation: 'اطلاعات اولیه مشتری',
      "Please enter the customer's full name. This step is required":
        'ابتدا نام و نام خانوادگی مشتری را وارد کنید. این مرحله اجباری می باشد.',
      'Advanced Details': 'اطلاعات تکمیلی',
      'You can optionally enter additional customer information here. This step is not mandatory':
        'در اینجا به طور دلخواه اطلاعات تکمیلی مشتریتان را می توانید بنویسید. نوشتن کامل این اطلاعات اجباری نیست .',
      'Phone Number': 'شماره تماس',
      "First, enter the country code, then enter the customer's phone number without the leading zero":
        'در این قسمت ابتدا کد کشور را وارد کرده و بعد شماره مشتری را بدون صفر اول وارد کنید. اگر آیکن واتساپ را فعال کنید سیستم معاملات مشتری را به شماره واتساپ وارد شده ارسال می کند.',
      MaknakUsername: 'نام کاربری مکنک',
      Maknak: 'مکنک',
      "The Maknak username is used to activate the customer's mobile app.":
        'نام کاربری مکنک برای فعال کردن اپلیکیشن موبایل مشتری شما می‌باشد. این قسمت به صورت اتوماتیک از شماره موبایل وارد شده در مرحله قبل پر می‌شود. در صورتی که مشتری شما اپلیکیشن را با نام کاربری به غیر از شماره موبایل وارد شده فعال کرده است، میتوانید آن شماره را اینجا بنویسید.',
      'customer account': 'حساب مشتری',
      "This step is the most important part of the customer account. Here, you register the customer's remaining balance.":
        'این مرحله مهمترین بخش حساب مشتری است. در این مرحله شما باقیمانده حساب مشتری که نزد شما است را در سیستم ثبت می کنید. اگر مشتری شما از چندین پول مختلف موجودی دارد با استفاده از علامت به علاوه می توانید آن را ثبت کنید.',
      'tutorial.dateFeature': 'ویژگی تاریخ',
      'tutorial.dateFeatureContent':
        'این ویژگی به شما امکان تغییر تاریخ تراکنش را می‌دهد',
      'tutorial.accountStatus': 'وضعیت حساب',
      'tutorial.accountStatusContent':
        'در این بخش می‌توانید وضعیت حساب انتخاب شده را مشاهده کنید',
      'tutorial.selectGroup': 'انتخاب گروه',
      'tutorial.selectGroupContent':
        'در این بخش می‌توانید گروه مربوط به هر تراکنش را انتخاب کنید',
      'tutorial.description': 'توضیحات',
      'tutorial.descriptionContent':
        'در این بخش می‌توانید توضیحات مربوط به تراکنش را وارد کنید',
      Back: 'بازگشت',
      'voiceRecorder.stopRecording': 'توقف ضبط',
      'voiceRecorder.recording': 'در حال ضبط...',
      'voiceRecorder.delete': 'حذف',
      'Important Notice': 'اطلاعیه مهم',
      'I Understand': 'متوجه شدم',
      'System Account': 'حساب سامانه',
      'Operation Type': 'نوع عملیات',
      Comma: '،',
      'Account Title': 'عنوان حساب',
      'Account Number': 'شماره حساب',
      'Credit Limit': 'سقف اعتبار',
      UncertainCreditLimit:
        'در صورت مشخص نکردن سقف اعتبار، سقف اعتبار صفر در نظر گرفته می‌شود',
      Unlimited: 'نامحدود',
      Add: 'افزودن',
      HasAccountInitialBalance: 'حساب موجودی اولیه دارد؟',
      'No Option Message': 'موردی وجود ندارد',
      'Upload a logo for the header': 'آپلود لوگو برای سربرگ',
      HeaderUploaderTitle: 'طول و عرض تصویر سربرگ باید یکسان باشد.',
      ViewHeader: 'مشاهده سربرگ',
      'Transaction Type': 'نوع تراکنش',
      AllBranches: 'همه نمایندگی‌ها',
      DepartmentsList: 'لیست شعب',
      Group: 'گروه',
      All: 'همه',
      Groups: 'گروه‌ها',
      AllCashDesks: 'همه صندوق‌ها',
      Weak: 'ضعیف',
      Medium: 'متوسط',
      Good: 'خوب',
      Excellent: 'عالی',
      AllOptions: 'همه موارد',
      'Communication Way': 'نوع تماس با شماره',
      Cancel: 'انصراف',
      AllCurrencies: 'همه ارزها',
      currency: 'ارز',
      Account: 'حساب',
      Bank: 'بانک',
      'Bank Information': 'اطلاعات بانک',
      Clear: 'پاک کردن',
      OK: 'تایید',
      Delete: 'حذف',
      Description: 'توضیحات',
      'Document Type': 'نوع مدرک',
      AllEmployees: 'همه کارمندان',
      'no attachments': 'ضمیمه ندارد',
      'File size exceeds limit': 'اندازه فایل از حد مجاز بیشتر است',
      'File with name already exists': 'فایل با این نام قبلاً وجود دارد',
      'Connected With Data': 'متصل با داده',
      'Connected Without Data': 'متصل بدون داده',
      'Retry (Application Is Not Running)':
        'تلاش مجدد (برنامه در حال اجرا نیست)',
      Gender: 'جنسیت',
      Colon: ':',
      Deposit: 'دریافت',
      Withdraw: 'پرداخت',
      'In progress': 'در حال پردازش',
      'No Content Message': 'موردی وجود ندارد',
      NotActiveSystemError: 'سامانه برای شما فعال نیست!',
      ExpiredSubscriptionError: 'زمان اشتراک شما به پایان رسیده است!',
      SubscriptionTimeUntilDate: 'زمان اشتراک شما تا تاریخ',
      HasBeen: 'بوده است',
      ReActiveAccountTitle: 'برای فعال‌سازی مجدد دکمه خرید نسخه را کلیک کنید.',
      ConnectedBranches: 'نمایندگی های متصل',
      BuyVersion: 'خرید نسخه',
      buyVersionTitle: 'برای استفاده از سامانه آریانا ابتدا نسخه خریداری کنید.',
      BalanceAmount: 'مقدار موجودی',
      Debtor: 'بدهکار',
      Creditor: 'طلبکار',
      SyncBalanceAndCreditLimit: 'همگام سازی موجودی با سقف اعتبار',
      Inventory: 'موجودی',
      Percent: 'درصد',
      '0to50ValidPercentage': 'درصد باید بین 0 تا 50 باشد',
      'form.organization': 'سازمان',
      Dollar: 'دلار',
      Equal: 'معادل',
      DollarRate: 'نرخ دلار',
      CalculationType: 'نوع محاسبه',
      Division: 'تقسیم',
      Multiplication: 'ضرب',
      Prepayments: 'پیش پرداخت ها',
      AdvancePurchaseContracts: 'قرارداد های پیش خرید',
      Assets: 'دارایی ها',
      TangibleAssets: 'دارایی های ملموس',
      ReductionInTangibleAssets: 'کاهش استهلاکات دارایی های ملموس',
      IntangibleAssets: 'دارایی های غیر ملموس',
      DepreciationOfIntangibleAssets: 'کاهش استهلاکات دارایی های غیر ملموس',
      PayableBills: 'بل های قابل پرداخت',
      PayableTaxes: 'مالیات قابل پرداخت',
      AdvanceSalesContracts: 'قرارداد های پیش فروش',
      AdministrativeExpenses: 'مصارف اداری',
      TelephoneAndCommunicationExpenses: 'مصارف تیلیفون و مکالماتی',
      RentExpenses: 'مصارف کرایه',
      Insurance: 'بیمه',
      Partners: 'شرکا',
      LicensingExpenses: 'مصارف اخذ جواز',
      EmployeeSalaries: 'معاشات کارمندان',
      ClaimsOnCentralBank: 'طلبات بالای ده افغانستان بانک',
      SelectRowAlert: 'ابتدا یک ردیف را انتخاب کنید.',
      'Due to the long number of letters of the selected document information, it is not possible to share.':
        'نظر به طولانی بودن تعداد حروف اطلاعات سند انتخابی، امکان اشتراک گذاری فراهم نیست.',
      Manual: 'دستی',
      'Document Prime': 'مدرک',
      IssuingOrganization: 'ارگان صادرکننده',
      Show: 'نمایش',
      'Currency Type': 'نوع ارز',
      'From Date': 'از تاریخ',
      TimeZone: 'منطقه زمانی',
      'Click to log out of WhatsApp': 'برای خروج از واتس‌اپ کلیک کنید',
      'Click to log in to WhatsApp': 'برای ورود به واتس‌اپ کلیک کنید',
      LogOutConfirmation:
        'آیا مطمئن هستید که می‌خواهید از حساب واتساپ خود خارج شوید؟',
      'Log Out': 'خروج',
      Return: 'بازگشت',
      PreventZoomModalTitle: 'برای تغییر سایز فونت از باکس زیر اقدام نمایید.',
      FontSize: 'اندازه فونت',
      large: 'بزرگ',
      medium: 'متوسط',
      small: 'کوچک',
      Submit: 'تایید',
      IncomingDraft: 'حواله آمد',
      OutgoingDraft: 'حواله رفت',
      'Draft Number': 'شماره حواله',
      'Other Number': 'شماره متفرقه',
      Sender: 'فرستنده',
      Receiver: 'گیرنده',
      'Draft Amount': 'مبلغ حواله',
      Commission: 'کارمزد',
      'Payment Place': 'محل پرداخت',
      Exchange: 'صرافی',
      Draft: 'حواله',
      'Transaction Description': 'شرح تراکنش',
      RemainingAccount: 'مانده حساب',
      Status: 'وضعیت',
      BranchAddress: 'آدرس نمایندگی',
      BranchPhone: 'تلفن نمایندگی',
      'Cash withdrawal': 'پرداخت نقدی',
      'Cash deposit': 'دریافت نقدی',
      To: 'به',
      From: 'از',
      Balance: 'باقی‌مانده',
      'Trade Currency': 'خرید و فروش ارز',
      Seller: 'فروشنده',
      'Sell Amount': 'مبلغ فروش',
      Buyer: 'خریدار',
      'Buy Amount': 'مبلغ خرید',
      Rate: 'نرخ',
      BankWithdraw: 'برداشت بانکی',
      BankDeposit: 'دریافت بانکی',
      'Bank Name': 'نام بانک',
      amount: 'مبلغ',
      'transfer between accounts': 'انتقال بین حساب',
      'Transaction Amount': 'مبلغ تراکنش',
      'Account Remaining': 'باقیمانده حساب',
      Date: 'تاریخ',
      'Customer Name': 'نام مشتری',
      AmountAccountWhatsappReport:
        'بدینوسیله تایید می گردد که جمع مانده حساب شما به صورت زیر می باشد :',
      BranchName: 'نام نمایندگی',
      Remaining: 'باقیمانده',
      New: 'جدید',
      'Under Review': 'درحال بررسی',
      Failed: 'رد شده',
      Done: 'انجام شده',
      'transactionType.buy': 'خرید',
      'transactionType.sell': 'فروش',
      Received: 'دریافتی',
      Paid: 'پرداختی',
      to: 'به',
      'Account Balance': 'موجودی حساب',
      'Sample Balance': '5/435/000',
      'Sample Balance Currency': 'تومان',
      dir: 'rtl',
      'Your Credit': 'اعتبار شما',
      Languages: 'زبان‌ها',
      Messages: 'پیام‌ها',
      'Mirror Branch': 'نمایندگی مقابل',
      Notifications: 'اعلان‌ها',
      'Quick Access': 'دسترسی سریع',
      Pages: 'صفحات',
      'System Settings': 'تنظیمات سامانه',
      UserAccountSystem: 'سامانه حساب کاربری',
      AccountingSystem: 'سامانه حسابداری',
      CurrencyAuction: 'لیلام اسعار',
      SanctionList: 'تطبیق لیست تعزیرات',
      'Central analysis of trades and financial reports':
        'مرکز تحلیل معاملات و راپورهای مالی',
      'Exchange license validation': 'اعتبارسنجی جواز',
      'Organization Chart': 'چارت سازمانی',
      ExitFromSystem: 'خروج از برنامه',
      'newFeatures.title': 'ویژگی‌های جدید',
      'newFeatures.excelExport': 'خروجی اکسل کل داده‌ها',
      'newFeatures.excelExportDescription':
        'اکنون می‌توانید تمام اطلاعات خود را به صورت فایل اکسل از بخش گزارشات و صفحه خروجی اکسل دانلود کنید.',
      'newFeatures.excelCustomerRegistration': 'ثبت مشتری با فایل اکسل',
      'newFeatures.excelCustomerRegistrationDescription':
        'کاربران اکنون می‌توانند فایل اکسل حاوی لیست چندین مشتری را در بخش لیست مشتریان و ورود داده‌ها بارگذاری کنند تا چندین مشتری را به صورت همزمان ثبت و به لیست خود اضافه نمایند.',
      'newFeatures.priceToText': 'تبدیل و نمایش مبلغ وارد شده به حروف',
      'newFeatures.priceToTextDescription':
        'اکنون می‌توانید گیرنده حواله ناشناس را از بین گیرندگان انتخاب یا به صورت دستی در صفحه اجرای حواله مشخص کنید.',
      'newFeatures.ticketShortcuts': 'میانبرهای ثبت تیکت',
      'newFeatures.ticketShortcutsDescription':
        'در حال حاضر هنگام ثبت تیکت، با Shift+Enter به خط بعد بروید و با Enter تیکت را ثبت کنید.',
      SystemNewFeatures: 'ویژگی‌های جدید سامانه',
      Close: 'بستن',
      Next: 'بعدی',
      'Add Ticket': 'ثبت تیکت',
      SubmitBugReportSuccessfully:
        'گزارش خطا باموفقیت ثبت شد و در اسرع وقت پاسخ داده خواهد شد.',
      TicketTitle: 'عنوان تیکت',
      GetScreenShout: 'اسکرین شات از صفحه',
      AddFile: 'در صورت لزوم فایل اضافه کنید.',
      OrderDetails: 'جزئیات خرید',
      'Mobile Number': 'شماره موبایل',
      Operator: 'اپراتور',
      package: 'پکیج',
      'Select or enter Charge amount': 'مقدار شارژ را وارد و یا انتخاب کنید.',
      chargeAmount: 'مبلغ شارژ',
      Accept: 'تایید',
      Continue: 'ادامه',
      'Date And Time': 'تاریخ و زمان',
      PaymentAmount: 'مبلغ پرداختی',
      trackingNumber: 'شماره پیگیری',
      orderStatusMessage:
        'سفارش شما ثبت شده و بزودی انجام می‌شود. می‌توانید وضعیت آن را در تب تراکنش‌ها پیگیری کنید.',
      'Visit Transactions': 'مشاهده تراکنش‌ها',
      InProgress: 'درحال انجام',
      BePatient: 'صبور باشید',
      'No Submited Transaction': 'تراکنشی ثبت نشده است',
      PubgId: 'آیدی پابجی',
      LikeeId: 'آیدی لایکی',
      SelectDesirePackage: 'بسته‌ موردنظر خود را انتخاب کنید',
      MaknakApp: 'اپلیکیشن مکنک',
      'buy charge': 'خرید شارژ',
      'buy internet': 'خرید اینترنت',
      buySnap: 'شارژ اسنپ',
      barghararCharge: 'شارژ برقرار',
      Bargharar: 'برقرار',
      'Bargharar Services': 'خدمات برقرار',
      'Buy Package': 'خرید بسته',
      'Wallet Charge': 'شارژ کیف پول',
      'Check Number Exists': 'بررسی شماره',
      'User does not exist': 'کاربر وجود ندارد',
      Amount: 'مبلغ',
      imoCharge: 'شارژ ایمو',
      pubgCharge: 'شارژ پابجی',
      Services: 'سرویس‌ها',
      Transactions: 'تراکنش‌ها',
      SelectAccountTitle: 'لطفا ابتدا حساب موردنظرتان را انتخاب کنید',
      Links: 'پیوندها',
      Moneyx: 'مانیکس',
      Credit: 'اعتبار',
      night: 'شب',
      day: 'روز',
      'Sign Out': 'خروج',
      Update: 'بروزرسانی',
      'New Version Available Phrase':
        'نسخه جدید سامانه در دسترس است ؛ لطفا صفحه را بروزرسانی کنید',
      'Sample Person': 'معین ربطی',
      ErrorPage: 'صفحه خطا',
      'utils.accountCode': 'کد حساب',
      'utils.name': 'نام',
      'utils.lastName': 'نام خانوادگی',
      'utils.phoneNumber': 'شماره تلفن',
      'utils.countryCode': 'کد کشور',
      'utils.inputAmount': 'مبلغ ورودی',
      'utils.currencyNotIncluded':
        'ارز "{{currencyCode}}" در ردیف {{rowNumber}} در لیست ارزهای شما وجود ندارد',
      'utils.debtorCreditor': 'بدهکار/بستانکار',
      'utils.gender': 'جنسیت',
      'utils.firstRowEmpty': 'ردیف اول نمی‌تواند خالی باشد',
      'utils.lastRowNotFound': 'ردیف آخر پیدا نشد',
      'utils.rowsWithSameAccountDifferentName':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند نام متفاوت داشته باشند.',
      'utils.rowsWithSameAccountDifferentLastName':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند نام خانوادگی متفاوت داشته باشند.',
      'utils.rowsWithSameAccountDifferentFatherName':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند نام پدر متفاوت داشته باشند.',
      'utils.rowsWithSameAccountDifferentPhone':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند شماره تلفن متفاوت داشته باشند.',
      'utils.rowsWithSameAccountSameCurrency':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند کد ارز یکسان داشته باشند.',
      'utils.rowsWithSameAccountDifferentCountry':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند کد کشور متفاوت داشته باشند.',
      'utils.rowsWithSameAccountDifferentGender':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند جنسیت متفاوت داشته باشند.',
      'utils.rowsWithSameAccountDifferentGroup':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند گروه متفاوت داشته باشند.',
      'utils.rowsWithSameAccountDifferentCategory':
        'ردیف‌هایی با شماره حساب {{accountTitle}} نمی‌توانند دسته‌بندی متفاوت داشته باشند.',
      'utils.differentAccountsSamePhone':
        'ردیف‌هایی با شماره حساب‌های متفاوت {{account1}} و {{account2}} نمی‌توانند شماره تلفن یکسان داشته باشند',
      'utils.currencyAmountDebtorCreditorRequired':
        'در هر ردیف، ارز-مبلغ-بدهکار/بستانکار باید یا همه پر شده باشند یا همه خالی باشند.',
      'utils.phoneCountryCodeRequired':
        'در هر ردیف، شماره تلفن و کد کشور باید یا هر دو پر باشند یا هر دو خالی.',
      'utils.invalidValueInRow':
        'مقدار "{{cellError}}" در ردیف "{{rowNumber}}" برای ستون "{{columnValue}}" مقدار قابل قبولی نیست.',
      'utils.accountCannotHaveDifferentValues':
        'کد حساب {{accountNumber}} نمی‌تواند مقادیر متفاوتی در {{columnTitle}} داشته باشد',
      'table.calculate': 'محاسبه {{column}}',
      'table.column': 'ستون',
      'table.rowCount': 'تعداد ردیف',
      'table.minimum': 'حداقل',
      'table.maximum': 'حداکثر',
      'table.sum': 'مجموع',
      'table.average': 'میانگین',
      CalculationBalance: 'درحال محاسبه باقی‌مانده',
      Known: 'معلوم',
      Unknown: 'نامعلوم',
      'bankTransaction.selectBankFirst': 'لطفاً ابتدا بانک را انتخاب کنید.',
      SelectDocument: 'انتخاب سند',
      TransactionBeWithoutDescription: 'تراکنش بدون ثبت توضیحات باشد',
      SyncCreditLimit: 'همگام سازی سقف اعتبار',
      PublishTransactionInWhatsapp: 'اعلان تراکنش به‌صورت پیش‌فرض',
      'Trade Rate': 'نرخ تبدیل',
      positiveTradeRate: 'نرخ تبدیل باید بیشتر از صفر باشد.',
      invalidTradeRate: 'نرخ تبدیل معتبر نیست',
      TheWayOfTransaction: 'نحوه انجام تراکنش به چه شکل باشد؟',
      BaseOnAmount: 'مبلغ محور باشه',
      BaseOnRate: 'نرخ‌محور باشه',
      SelectItemToAutoCalculate: 'کدام آیتم به صورت خودکار محاسبه شود؟',
      'triplex.sellAmount': 'مبلغ فروش',
      'triplex.buyAmount': 'مبلغ خرید',
      'triplex.conversionRate': 'نرخ تبدیل',
      'Calculating Profit and Loss': 'محاسبه‌گر سود و زیان',
      'System Rate': 'نرخ سامانه',
      bankStatusMessage2:
        'پس از انتخاب بانک، مانده حساب بانک نمایش داده می‌شود',
      BankAccountBalance: 'مانده حساب بانک',
      Deposit2: 'واریز',
      Withdraw2: 'برداشت',
      'bankTransaction.document': 'سند {{transactionType}}',
      PaymentType: 'نوع پرداخت',
      'bankTransaction.oldTransaction': '{{transactionType}} قدیمی',
      'bankTransaction.transactionDate': 'تاریخ تراکنش',
      'Transaction Number': 'شماره تراکنش',
      Branch: 'نمایندگی',
      Settings: 'تنظیمات',
      'creditAccount.balance': 'مانده حساب اعتباری',
      AccountStatusMessage:
        'پس از انتخاب مشتری، مانده حساب مشتری نمایش داده می‌شود.',
      CustomerAccountRemaining: 'مانده حساب مشتری',
      'draggableList.paymentPlace': 'محل پرداخت',
      Edit: 'ویرایش',
      'draggableList.delete': 'حذف',
      AddPaymentPlace: 'افزودن محل پرداخت',
      Enable: 'فعال‌سازی',
      Webcam: 'وبکم',
      'Upload File': 'آپلود فایل',
      NoBalanceIsThere: 'هیچ موجودی ثبت نشده است.',
      'previewImages.viewDocuments': 'مشاهده اسناد',
      'providerService.selectOrganizationFirst':
        'پس از انتخاب سازمان، مانده حساب سازمان به صورت جداگانه نمایش داده می‌شود.',
      'providerService.organizationBalance': 'مانده حساب سازمان',
      Search: 'جستجو',
      ShowLess: 'نمایش کمتر',
      ShowMore: 'نمایش بیشتر',
      'switchableWhatsapp.noNotification':
        'تراکنش در واتساپ اطلاع‌رسانی نمی‌شود',
      'updateNotification.systemUpdate':
        'سیستم در تاریخ {{date}} از ساعت {{startTime}} تا {{endTime}} به‌روزرسانی خواهد شد.',
      'Activating WhatsApp': 'فعال کردن واتساپ',
      WhitsappTitle:
        'درحال دریافت اطلاعات از واتساپ، این فرایند ممکن است کمی زمان‌بر باشد.',
      ConnectionTitle: 'برای اتصال، کد زیر را اسکن کنید.',
      ScanQrTitle:
        'پس از اسکن QrCode کاربر آریانا را از دستگاه‌های متصل خارج نکنید.',
      ScanQrAlert:
        'فرایند اسکن و اتصال به واتساپ تنها یکبار و در تمامی تراکنش‌ها صورت میگیرد.',
      'freeSolo.senderName': 'نام کامل فرستنده',
      'freeSolo.paymentPlace': 'محل پرداخت',
      'Fingerprint registered successfully': 'اثر انگشت با موفقیت ثبت شد',
      RepeatOperation: 'تکرار عملیات',
      'Accept And Register': 'تایید و ثبت',
      UseDesktopVersionTitle:
        'جهت فعال کردن این امکان، از نسخه دسکتاپ نرم‌افزار استفاده کنید.',
      TransferBetweenTwoAccounts: 'انتقال بین حساب',
      CashTransaction: 'تراکنش نقدی',
      Miscellaneous: 'متفرقه',
      BuySellCurrency: 'خرید و فروش ارز',
      BankTransaction: 'تراکنش بانکی',
      ExecuteDraft: 'اجرای حواله',
      Cheque: 'چک',
      InterBankTransaction: 'تراکنش بین بانکی',
      PaymentOrderReceipt: 'رسید دستور پرداخت',
      ChangeBranch: 'تبدیل نرخ',
      UnknownBankTransaction: 'تراکنش نامعلوم بانکی',
      AddNewAccount: 'افزودن حساب جدید',
      UpdateAccount: 'ویرایش حساب',
      DeleteAccount: 'حذف حساب',
      AddBank: 'افزودن بانک',
      UpdateBank: 'ویرایش بانک',
      DeleteBank: 'حذف بانک',
      AddCustomer: 'افزودن مشتری',
      UpdateCustomer: 'ویرایش مشتری',
      DeleteCustomer: 'حذف مشتری',
      AddCompany: 'افزودن شرکت',
      UpdateCompany: 'ویرایش شرکت',
      DeleteCompany: 'حذف شرکت',
      AddBranch: 'افزودن نمایندگی',
      UpdateBranch: 'ویرایش نمایندگی',
      DeleteBranch: 'حذف نمایندگی',
      AddCurrency: 'افزودن ارز',
      UpdateCurrency: 'ویرایش ارز',
      DeleteCurrency: 'حذف ارز',
      AddPayOrder: 'افزودن دستور پرداخت',
      UpdatePayOrder: 'ویرایش دستور پرداخت',
      DeletePayOrder: 'حذف دستور پرداخت',
      Checkout: 'تسویه',
      RemoveCheckout: 'حذف تسویه',
      PendDraft: 'حواله در انتظار',
      RemovePendDraft: 'حذف حواله در انتظار',
      IncreaseCredit: 'افزایش اعتبار',
      CancelDraft: 'لغو حواله',
      SavedToCustomerAccount: 'واگذار شده',
      HasReturned: 'برگشت خورده',
      CashedToMoney: 'پاس شده',
      SavedToCashDeskOrBankAccount: 'خوابانده شده',
      Normal: 'عادی',
      Telegram: 'تلگرام',
      Whatsapp: 'واتساپ',
      Other: 'سایر',
      Male: 'مرد',
      Female: 'زن',
      customer: 'مشتری',
      receiver: 'گیرنده',
      Passport: 'گذرنامه',
      'Physical Tezkire': 'تذکره کاغذی',
      'Electronic Tezkire': 'تذکره برقی',
      'National Card': 'کارت ملی',
      'Birth Certificate': 'شناسنامه',
      'Kimlik Card': 'کارت کیملیک',
      'Driving License': 'گواهینامه',
      Germany: 'آلمان',
      Sweden: 'سوئد',
      Norway: 'نروژ',
      Greece: 'یونان',
      Baghdad: 'بغداد',
      Ankara: 'آنکارا',
      'Saudi Arabia': 'عربستان سعودی',
      Tehran: 'تهران',
      'United Arab Emirates': 'امارات متحده عربی',
      Kabul: 'کابل',
      'Islamabad, Karachi': 'کراچی ,اسلام آباد',
      Australia: 'استرالیا',
      China: 'چین',
      'Moneyx Accounting Panel': 'پنل حسابداری مانیکس',
      Accounts: 'حساب‌ها',
      'Archived Accounts': 'حساب‌های آرشیو شده',
      'Journal Entries': 'دفتر روزنامه',
      'Bank Transaction': 'تراکنش بانکی',
      'Banks List': 'لیست بانک‌ها',
      Dashboard: 'داشبورد',
      Department: 'شعبه',
      'General Ledger': 'دفتر کل',
      'Branch Edition': 'ویرایش نمایندگی',
      'Branch Registration': 'ثبت نمایندگی',
      'Branches List': 'لیست نمایندگی‌ها',
      'Cash Transaction': 'تراکنش نقدی',
      'Cheques List': 'لیست چک‌ها',
      Reports: 'گزارشات',
      Registration: 'ثبت',
      'Commissions Report': 'گزارش کارمزد ها',
      'Edit Company': 'ویرایش شرکت',
      'Company Registration': 'ثبت شرکت',
      'Currencies Management': 'مدیریت ارزها',
      'Customers List': 'لیست مشتریان',
      profile: 'حساب کاربری',
      'System Management': 'مدیریت سامانه',
      'Operation of the day': 'عملیات روز',
      'Operation Of The Day': 'عملیات روز',
      'Debtor And Creditor List': 'لیست بدهکار و طلبکار',
      'Decrease Customer Credit': 'کاهش اعتبار مشتری',
      Drafts: 'حواله‌ها',
      'Draft Conduction': 'اجرای حواله',
      'Incoming Draft Submission': 'ثبت حواله آمد',
      'Miscellaneous Draft Submission': 'ثبت حواله متفرقه',
      'Outgoing Draft Submission': 'ثبت حواله رفت',
      'Draft Documents List': 'لیست اسناد حواله',
      'Unrealized Drafts List': 'لیست حواله‌های اجرا نشده',
      'Draft Orders List': 'لیست سفارشات حواله',
      'Excel Data Output': 'خروجی اکسل اطلاعات',
      'Financial Operation': 'عملیات مالی',
      'Increase Customer Credit': 'افزایش اعتبار مشتری',
      'Interbank Transaction': 'تراکنش بین بانکی',
      'Organizations List': 'لیست سازمان‌ها',
      'Payment Order': 'دستور پرداخت',
      'Pending Transactions List': 'لیست تراکنش‌های در انتظار',
      'Edit Person': 'ویرایش شخص',
      'Register Person': 'ثبت شخص',
      'Profit And Loss Statement': 'صورت سود و زیان',
      'Receivers List': 'لیست گیرنده‌ها',
      'Bug Details': 'جزئیات خطا',
      'Reported Bugs': 'خطاهای گزارش شده',
      'System Accounts': 'حساب‌های سامانه',
      'System Guides': 'راهنما کار با سامانه',
      'Trade Currencies List': 'لیست خرید و فروش ارز',
      'Transfer Between Accounts': 'انتقال بین حساب',
      'Unknown Bank Transactions': 'تراکنش‌های نامعلوم بانکی',
      'Bank Book': 'دفتر بانک',
      'Branch Account': 'حساب نمایندگی',
      'Customer Credit Account': 'حساب اعتبار مشتری',
      'My Tickets': 'تیکت‌های من',
      'Pending Drafts List': 'لیست حواله‌های در انتظار',
      English: 'انگلیسی',
      'language.persian': 'فارسی',
      'Accounting Panel': 'پنل حسابداری',
      Administrator: 'مدیر سیستم',
      'Submit Cash Transaction': 'ثبت تراکنش نقدی',
      'Submit Bank Transaction': 'ثبت تراکنش بانکی',
      'Credits Account': 'حساب اعتبارات',
      'Draft Submission': 'ثبت حواله',
      'Draft List': 'لیست حواله',
      Incoming: 'آمد',
      Outgoing: 'رفت',
      'Buy Currency': 'خرید ارز',
      'Sell Currency': 'فروش ارز',
      'Account Information': 'اطلاعات حساب',
      actionArchive: 'بایگانی کردن',
      Archived: 'بایگانی',
      AddAccount: 'افزودن حساب',
      unknownbankaccounts: 'تراکنش‌های نامعلوم بانکی',
      End: 'پایان',
      'Mirror Branch Account': 'حساب نمایندگی مقابل',
      MirrorBranchAccount: 'حساب نمایندگی مقابل',
      UnexecutedDraft: 'حواله‌های اجرا نشده',
      unexecuteddraft: 'حواله‌های اجرا نشده',
      'Mirror Branch Information': 'اطلاعات حساب نمایندگی مقابل',
      'Required field message': 'پرکردن این فیلد اجباری است',
      undestandAndDoNotShowAgain:
        'من مطالب بالا را مطالعه کردم، دیگر نشان نده.',
      Buy: 'خرید',
      noteCreatedSuccessfully: 'یادداشت با موفقیت ایجاد شد',
      DeleteNoteTitle: 'آیا از حذف این یادداشت اطمینان دارید؟',
      noteEditedSuccessfully: 'یادداشت با موفقیت ویرایش شد.',
      Notes: 'یادداشت‌ها',
      select: 'انتخاب کنید',
      PersonProfile: 'پروفایل شخص',
      'Bank Transactions': 'تراکنش‌های بانکی',
      General: 'عمومی',
      Banking: 'بانکی',
      Cost: 'هزینه'
    },
    dir: 'rtl'
  },
  fad: {
    translation: {
      TurkeyPhoneNumberValidation:
        'شماره تلفن ترکیه باید ۱۱ رقم باشد و با 05 شروع شود.',
      AfghanPhoneNumberValidation:
        'شماره تلفن افغانستان باید ۱۰ رقمی باشد و با ۰۷ شروع شود',
      'invalid number': 'شماره تلفن نامعتبر است.',
      'PhoneNumber must be 11 digits and start with 0':
        'شماره تلفن ایران باید ۱۱ رقمی باشد و با ۰۹ شروع شود',
      uploadFileWithTouch: 'برای بارگذاری فایل، لمس کنید',
      'Drop Your Desired File Here': 'فایل مورد نظر را اینجا رها کنید',
      Or: 'یا',
      Choose: 'انتخاب کنید',
      UseWebcam: 'از کمره استفاده کنید (CTRL + k)',
      uploaderInputLabelMaximumSize: 'حجم فایل حداکثر باید ۳مگابایت باشد',
      And: 'و',
      FileUploaderInputLabelFormat:
        'فرمت آن باید xls, xlsx, pdf, png, jpg, jpeg, doc, docx, webp باشد.',
      TakePicture: 'گرفتن عکس',
      CustomerBasicInformation: 'اطلاعات اولیه مشتری',
      "Please enter the customer's full name. This step is required":
        'لطفاً نام و تخلص مشتری را وارد کنید. این مرحله الزامی است.',
      'Advanced Details': 'اطلاعات پیشرفته',
      'You can optionally enter additional customer information here. This step is not mandatory':
        'در این قسمت میتوانید معلومات اضافی مشتری را بنویسید. این بخش الزامی نیست.',
      'Phone Number': 'شماره تماس',
      "First, enter the country code, then enter the customer's phone number without the leading zero":
        'لطفاً ابتدا کد کشور را وارد کنید و سپس شماره مشتری را بدون صفر اول وارد نمایید.',
      MaknakUsername: 'نام کاربری مکنک',
      Maknak: 'مکنک',
      "The Maknak username is used to activate the customer's mobile app.":
        'این قسمت به طور خودکار از شماره موبایل مشتری پر می‌شود.',
      'customer account': 'حساب مشتری',
      "This step is the most important part of the customer account. Here, you register the customer's remaining balance.":
        'در این مرحله حساب باقی‌مانده مشتری را وارد کنید.',
      'tutorial.dateFeature': 'ویژگی تاریخ آموزش',
      'tutorial.dateFeatureContent': 'محتوای ویژگی تاریخ آموزش',
      'tutorial.accountStatus': 'وضعیت حساب',
      'tutorial.accountStatusContent':
        'در این بخش وضعیت حساب انتخاب شده را میتوانید مشاهده بکنید.',
      'tutorial.selectGroup': 'انتخاب گروه آموزش',
      'tutorial.selectGroupContent': 'محتوای انتخاب گروه آموزش',
      'tutorial.description': 'توضیحات آموزش',
      'tutorial.descriptionContent': 'محتوای توضیحات آموزش',
      Back: 'بازگشت',
      'voiceRecorder.stopRecording': 'توقف ضبط صدا',
      'voiceRecorder.recording': 'ضبط صدا',
      'voiceRecorder.delete': 'حذف ضبط صدا',
      'Important Notice': 'اطلاعیه مهم',
      'I Understand': 'متوجه شدم',
      'System Account': 'حساب سیستم',
      'Operation Type': 'نوع عملیات',
      Comma: '،',
      'Account Title': 'عنوان حساب',
      'Account Number': 'شماره حساب',
      'Credit Limit': 'سقف اعتبار',
      UncertainCreditLimit:
        'در صورت مشخص نکردن سقف اعتبار، سقف اعتبار صفر در نظر گرفته می‌شود',
      Unlimited: 'نامحدود',
      Add: 'افزودن',
      HasAccountInitialBalance: 'حساب موجودی اولیه دارد؟',
      'No Option Message': 'موردی وجود ندارد',
      'Upload a logo for the header': 'آپلود لوگو برای سر ورقی',
      HeaderUploaderTitle: 'طول و عرض تصویر سربرگ باید یکسان باشد.',
      ViewHeader: 'مشاهده سربرگ',
      'Transaction Type': 'نوع معامله',
      AllBranches: 'همه نمایندگی‌ها',
      DepartmentsList: 'فهرست شعب',
      Group: 'گروه',
      All: 'همه',
      Groups: 'گروه‌ها',
      AllCashDesks: 'همه صندوق‌ها',
      Weak: 'ضعیف',
      Medium: 'متوسط',
      Good: 'خوب',
      Excellent: 'عالی',
      AllOptions: 'همه موارد',
      'Communication Way': 'راه ارتباطی',
      Cancel: 'لغو',
      AllCurrencies: 'همه ارزها',
      currency: 'ارز',
      Account: 'حساب',
      Bank: 'بانک',
      'Bank Information': 'اطلاعات بانک',
      Clear: 'پاک کردن',
      OK: 'تایید',
      Delete: 'حذف',
      Description: 'توضیحات',
      'Document Type': 'نوع مدرک',
      AllEmployees: 'همه کارمندان',
      'no attachments': 'ضمیمه ندارد',
      'File size exceeds limit': 'اندازه فایل از حد مجاز بیشتر است',
      'File with name already exists': 'فایل با این نام قبلاً وجود دارد',
      'Connected With Data': 'وصل شده با دیتا',
      'Connected Without Data': 'وصل نیست',
      'Retry (Application Is Not Running)':
        'تلاش مجدد (برنامه در حال اجرا نیست)',
      Gender: 'جنسیت',
      Colon: ':',
      Deposit: 'دریافت',
      Withdraw: 'پرداخت',
      'In progress': 'در حال پردازش',
      'No Content Message': 'موردی وجود ندارد',
      NotActiveSystemError: 'سیستم برای شما فعال نیست!',
      ExpiredSubscriptionError: 'زمان اشتراک شما به پایان رسیده است!',
      SubscriptionTimeUntilDate: 'زمان اشتراک شما تا تاریخ',
      HasBeen: 'بوده است',
      ReActiveAccountTitle: 'برای فعال‌سازی مجدد دکمه خرید نسخه را کلیک کنید.',
      ConnectedBranches: 'نمایندگی های متصل',
      BuyVersion: 'خرید نسخه',
      buyVersionTitle: 'برای استفاده از سیستم آریانا ابتدا نسخه خریداری کنید.',
      BalanceAmount: 'مقدار موجودی',
      Debtor: 'باقی‌دار',
      Creditor: 'طلبکار',
      SyncBalanceAndCreditLimit: 'همگام سازی موجودی با سقف اعتبار',
      Inventory: 'موجودی',
      Percent: 'درصد',
      '0to50ValidPercentage': 'فیصدی باید بین ۰ تا ۵۰ باشد',
      'form.organization': 'سازمان',
      Dollar: 'دالر',
      Equal: 'معادل',
      DollarRate: 'نرخ دلار',
      CalculationType: 'نوع محاسبه',
      Division: 'تقسیم',
      Multiplication: 'ضرب',
      Prepayments: 'پیش پرداخت ها',
      AdvancePurchaseContracts: 'قرارداد های پیش خرید',
      Assets: 'دارایی ها',
      TangibleAssets: 'دارایی های ملموس',
      ReductionInTangibleAssets: 'کاهش استهلاکات دارایی های ملموس',
      IntangibleAssets: 'دارایی های غیر ملموس',
      DepreciationOfIntangibleAssets: 'کاهش استهلاکات دارایی های غیر ملموس',
      PayableBills: 'بل های قابل پرداخت',
      PayableTaxes: 'مالیات قابل پرداخت',
      AdvanceSalesContracts: 'قرارداد های پیش فروش',
      AdministrativeExpenses: 'مصارف اداری',
      TelephoneAndCommunicationExpenses: 'مصارف تیلیفون و مکالماتی',
      RentExpenses: 'مصارف کرایه',
      Insurance: 'بیمه',
      Partners: 'شرکا',
      LicensingExpenses: 'مصارف اخذ جواز',
      EmployeeSalaries: 'معاشات کارمندان',
      ClaimsOnCentralBank: 'طلبات بالای ده افغانستان بانک',
      SelectRowAlert: 'ابتدا یک ردیف را انتخاب کنید.',
      'Due to the long number of letters of the selected document information, it is not possible to share.':
        'نظر به طولانی بودن تعداد حروف اطلاعات سند انتخابی، امکان اشتراک گذاری فراهم نیست.',
      Manual: 'دستی',
      'Document Prime': 'مدرک',
      IssuingOrganization: 'ارگان صادرکننده',
      Show: 'نمایش',
      'Currency Type': 'نوع ارز',
      'From Date': 'از تاریخ',
      TimeZone: 'منطقه زمانی',
      'Click to log out of WhatsApp': 'روی خروج از واتس‌اپ کلیک کنید',
      'Click to log in to WhatsApp': 'روی ورود به واتس‌اپ کلیک کنید',
      LogOutConfirmation:
        'آیا مطمئن هستید که می‌خواهید از حساب واتساپ خود خارج شوید؟',
      'Log Out': 'برآمدن',
      Return: 'بازگشت',
      PreventZoomModalTitle:
        'برای تغییر اندازهٔ خط، از جعبهٔ زیر استفاده کنید.',
      FontSize: 'اندازه فونت',
      large: 'بزرگ',
      medium: 'متوسط',
      small: 'کوچک',
      Submit: 'تایید',
      IncomingDraft: 'حواله آمد',
      OutgoingDraft: 'حواله رفت',
      'Draft Number': 'شماره حواله',
      'Other Number': 'شماره متفرقه',
      Sender: 'فرستنده',
      Receiver: 'گیرنده',
      'Draft Amount': 'مبلغ حواله',
      Commission: 'کمیشن',
      'Payment Place': 'محل پرداخت',
      Exchange: 'صرافی',
      Draft: 'حواله',
      'Transaction Description': 'شرح معامله',
      RemainingAccount: 'مانده حساب',
      Status: 'وضعیت',
      BranchAddress: 'آدرس نمایندگی',
      BranchPhone: 'تلفن نمایندگی',
      'Cash withdrawal': 'پرداخت نقدی',
      'Cash deposit': 'دریافت نقدی',
      To: 'تا',
      From: 'از',
      Balance: 'بیلانس',
      'Trade Currency': 'تبادله اسعار',
      Seller: 'فروشنده',
      'Sell Amount': 'مبلغ فروش',
      Buyer: 'خریدار',
      'Buy Amount': 'مبلغ خرید',
      Rate: 'نرخ',
      BankWithdraw: 'برداشت بانکی',
      BankDeposit: 'دریافت بانکی',
      'Bank Name': 'نام بانک',
      amount: 'مبلغ',
      'transfer between accounts': 'انتقال بین حساب',
      'Transaction Amount': 'مبلغ معامله',
      'Account Remaining': 'بیلانس حساب',
      Date: 'تاریخ',
      'Customer Name': 'نام مشتری',
      AmountAccountWhatsappReport:
        'بدینوسیله تایید می گردد که جمع مانده حساب شما به صورت زیر می باشد :',
      BranchName: 'نام نمایندگی',
      Remaining: 'بیلانس',
      New: 'جدید',
      'Under Review': 'درحال بررسی',
      Failed: 'ناموفق',
      Done: 'انجام شده',
      'transactionType.buy': 'نوع تراکنش خرید',
      'transactionType.sell': 'نوع تراکنش فروش',
      Received: 'دریافتی',
      Paid: 'پرداختی',
      to: 'به',
      'Account Balance': 'بیلانس حساب',
      'Sample Balance': '5/435/000',
      'Sample Balance Currency': 'افغانی',
      dir: 'rtl',
      'Your Credit': 'اعتبار شما',
      Languages: 'زبان‌ها',
      Messages: 'پیام‌ها',
      'Mirror Branch': 'نمایندگی مقابل',
      Notifications: 'اعلان‌ها',
      'Quick Access': 'دسترسی سریع',
      Pages: 'صفحات',
      'System Settings': 'تنظیمات سیستم',
      UserAccountSystem: 'سیستم حساب کاربری',
      AccountingSystem: 'سیستم حسابداری',
      CurrencyAuction: 'لیلام اسعار',
      SanctionList: 'تطبیق لیست تعزیرات',
      'Central analysis of trades and financial reports':
        'مرکز تحلیل معاملات و راپورهای مالی',
      'Exchange license validation': 'اعتبارسنجی جواز',
      'Organization Chart': 'چارت تشکیلاتی',
      ExitFromSystem: 'خروج از برنامه',
      'newFeatures.title': 'عنوان ویژگی‌های جدید',
      'newFeatures.excelExport': 'خروجی اکسل ویژگی‌های جدید',
      'newFeatures.excelExportDescription': 'توضیحات خروجی اکسل ویژگی‌های جدید',
      'newFeatures.excelCustomerRegistration': 'ثبت مشتری با فایل اکسل',
      'newFeatures.excelCustomerRegistrationDescription':
        'کاربران اکنون می‌توانند فایل اکسل حاوی لیست چندین مشتری را در بخش لیست مشتریان و ورود داده‌ها بارگذاری کنند تا چندین مشتری را به صورت همزمان ثبت و به لیست خود اضافه نمایند.',
      'newFeatures.priceToText': 'قیمت به متن ویژگی‌های جدید',
      'newFeatures.priceToTextDescription':
        'توضیحات قیمت به متن ویژگی‌های جدید',
      'newFeatures.ticketShortcuts': 'کلیدهای میانبر تیکت ویژگی‌های جدید',
      'newFeatures.ticketShortcutsDescription':
        'توضیحات کلیدهای میانبر تیکت ویژگی‌های جدید',
      SystemNewFeatures: 'ویژگی‌های جدید سیستم',
      Close: 'بستن',
      Next: 'بعدی',
      'Add Ticket': 'ثبت تیکت',
      SubmitBugReportSuccessfully:
        'گزارش خطا باموفقیت ثبت شد و در اسرع وقت پاسخ داده خواهد شد.',
      TicketTitle: 'عنوان تیکت',
      GetScreenShout: 'اسکرین شات از صفحه',
      AddFile: 'در صورت لزوم فایل اضافه کنید.',
      OrderDetails: 'جزئیات خرید',
      'Mobile Number': 'شماره موبایل',
      Operator: 'اپراتور',
      package: 'پکیج',
      'Select or enter Charge amount': 'مقدار شارژ را وارد و یا انتخاب کنید.',
      chargeAmount: 'مبلغ شارژ',
      Accept: 'تایید',
      Continue: 'ادامه',
      'Date And Time': 'تاریخ و زمان',
      PaymentAmount: 'مبلغ پرداختی',
      trackingNumber: 'شماره پیگیری',
      orderStatusMessage:
        'سفارش شما ثبت شده و بزودی انجام می‌شود. می‌توانید وضعیت آن را در تب تراکنش‌ها پیگیری کنید.',
      'Visit Transactions': 'مشاهده تراکنش‌ها',
      InProgress: 'درحال انجام',
      BePatient: 'صبور باشید',
      'No Submited Transaction': 'معامله‌ای ثبت نشده است',
      PubgId: 'آیدی پابجی',
      LikeeId: 'آیدی لایکی',
      SelectDesirePackage: 'بسته‌ موردنظر خود را انتخاب کنید',
      MaknakApp: 'اپلیکیشن مکنک',
      'buy charge': 'خرید شارژ',
      'buy internet': 'خرید اینترنت',
      buySnap: 'شارژ اسنپ',
      barghararCharge: 'شارژ برقرار',
      Bargharar: 'برقرار',
      'Bargharar Services': 'خدمات برقرار',
      'Buy Package': 'خرید بسته',
      'Wallet Charge': 'شارژ کیف پول',
      'Check Number Exists': 'بررسی وجود شماره',
      'User does not exist': 'کاربر وجود ندارد',
      Amount: 'مبلغ',
      imoCharge: 'شارژ ایمو',
      pubgCharge: 'شارژ پابجی',
      Services: 'سرویس‌ها',
      Transactions: 'معاملات',
      SelectAccountTitle: 'لطفا ابتدا حساب موردنظرتان را انتخاب کنید',
      Links: 'پیوندها',
      Moneyx: 'مانیکس',
      Credit: 'اعتبار',
      night: 'شب',
      day: 'روز',
      'Sign Out': 'خروج',
      Update: 'بروزرسانی',
      'New Version Available Phrase':
        'نسخه جدید سیستم در دسترس است ؛ لطفا صفحه را بروزرسانی کنید',
      'Sample Person': 'معین ربطی',
      ErrorPage: 'صفحه خطا',
      'utils.accountCode': 'کد حساب',
      'utils.name': 'نام',
      'utils.lastName': 'نام خانوادگی',
      'utils.phoneNumber': 'شماره تلفن',
      'utils.countryCode': 'کد کشور',
      'utils.inputAmount': 'مبلغ ورودی',
      'utils.currencyNotIncluded': 'ارز شامل نشده',
      'utils.debtorCreditor': 'بدهکار بستانکار',
      'utils.gender': 'جنسیت',
      'utils.firstRowEmpty': 'ردیف اول خالی',
      'utils.lastRowNotFound': 'ردیف آخر یافت نشد',
      'utils.rowsWithSameAccountDifferentName':
        'ردیف‌های با حساب یکسان نام مختلف',
      'utils.rowsWithSameAccountDifferentLastName':
        'ردیف‌های با حساب یکسان نام خانوادگی مختلف',
      'utils.rowsWithSameAccountDifferentFatherName':
        'ردیف‌های با حساب یکسان نام پدر مختلف',
      'utils.rowsWithSameAccountDifferentPhone':
        'ردیف‌های با حساب یکسان تلفن مختلف',
      'utils.rowsWithSameAccountSameCurrency':
        'ردیف‌های با حساب یکسان ارز یکسان',
      'utils.rowsWithSameAccountDifferentCountry':
        'ردیف‌های با حساب یکسان کشور مختلف',
      'utils.rowsWithSameAccountDifferentGender':
        'ردیف‌های با حساب یکسان جنسیت مختلف',
      'utils.rowsWithSameAccountDifferentGroup':
        'ردیف‌های با حساب یکسان گروه مختلف',
      'utils.rowsWithSameAccountDifferentCategory':
        'ردیف‌های با حساب یکسان دسته‌بندی مختلف',
      'utils.differentAccountsSamePhone': 'حساب‌های مختلف شماره تلفن یکسان',
      'utils.currencyAmountDebtorCreditorRequired':
        'مبلغ ارز بدهکار بستانکار الزامی است',
      'utils.phoneCountryCodeRequired': 'کد کشور تلفن الزامی است',
      'utils.invalidValueInRow':
        'مقدار "{{cellError}}" در ردیف "{{rowNumber}}" برای ستون "{{columnValue}}" مقدار قابل قبولی نیست.',
      'utils.accountCannotHaveDifferentValues':
        'حساب نمی‌تواند مقادیر مختلف داشته باشد',
      'table.calculate': 'محاسبه جدول',
      'table.column': 'ستون جدول',
      'table.rowCount': 'تعداد ردیف جدول',
      'table.minimum': 'حداقل جدول',
      'table.maximum': 'حداکثر جدول',
      'table.sum': 'مجموع جدول',
      'table.average': 'میانگین جدول',
      CalculationBalance: 'درحال محاسبه باقی‌مانده',
      Known: 'معلوم',
      Unknown: 'نامعلوم',
      'bankTransaction.selectBankFirst': 'ابتدا بانک مورد نظر را انتخاب کنید.',
      SelectDocument: 'انتخاب سند',
      TransactionBeWithoutDescription: 'معامله بدون ثبت توضیحات باشد',
      SyncCreditLimit: 'همگام سازی سقف اعتبار',
      PublishTransactionInWhatsapp: 'اعلان پیش‌فرض معامله',
      'Trade Rate': 'نرخ تبدیل',
      positiveTradeRate: 'نرخ تبدیل باید بیشتر از صفر باشد.',
      invalidTradeRate: 'نرخ تبدیل معتبر نیست',
      TheWayOfTransaction: 'نحوه انجام معامله به چه شکل باشد؟',
      BaseOnAmount: 'مبلغ محور باشه',
      BaseOnRate: 'نرخ‌محور باشه',
      SelectItemToAutoCalculate: 'کدام آیتم به صورت خودکار محاسبه شود؟',
      'triplex.sellAmount': 'مبلغ فروش سه‌گانه',
      'triplex.buyAmount': 'مبلغ خرید سه‌گانه',
      'triplex.conversionRate': 'نرخ تبدیل سه‌گانه',
      'Calculating Profit and Loss': 'سود و ضرر تخمینی',
      'System Rate': 'نرخ سیستم',
      bankStatusMessage2:
        'پس از انتخاب بانک، مانده حساب بانک نمایش داده می‌شود',
      BankAccountBalance: 'مانده حساب بانک',
      Deposit2: 'واریز',
      Withdraw2: 'برداشت',
      'bankTransaction.document': 'سند {{transactionType}}',
      PaymentType: 'نوع پرداخت',
      'bankTransaction.oldTransaction': '{{transactionType}} قدیم',
      'bankTransaction.transactionDate': 'تاریخ تراکنش',
      'Transaction Number': 'شماره معامله',
      Branch: 'نمایندگی',
      Settings: 'تنظیمات',
      'creditAccount.balance': 'موجودی حساب اعتباری',
      AccountStatusMessage:
        'پس از انتخاب مشتری، مانده حساب مشتری نمایش داده می‌شود.',
      CustomerAccountRemaining: 'مانده حساب مشتری',
      'draggableList.paymentPlace': 'محل پرداخت لیست قابل کشیدن',
      Edit: 'ویرایش',
      'draggableList.delete': 'حذف لیست قابل کشیدن',
      AddPaymentPlace: 'افزودن محل پرداخت',
      Enable: 'فعال‌سازی',
      Webcam: 'کمره',
      'Upload File': 'آپلود فایل',
      NoBalanceIsThere: 'هیچ موجودی ثبت نشده است.',
      'previewImages.viewDocuments': 'مشاهده اسناد پیش‌نمایش تصاویر',
      'providerService.selectOrganizationFirst':
        'ابتدا سازمان را انتخاب کنید سرویس ارائه‌دهنده',
      'providerService.organizationBalance': 'موجودی سازمان سرویس ارائه‌دهنده',
      Search: 'جستجو',
      ShowLess: 'نمایش کمتر',
      ShowMore: 'نمایش بیشتر',
      'switchableWhatsapp.noNotification': 'بدون اعلان واتساپ قابل تغییر',
      'updateNotification.systemUpdate': 'به‌روزرسانی سیستم اعلان به‌روزرسانی',
      'Activating WhatsApp': 'فعال کردن واتساپ',
      WhitsappTitle:
        'در حال دریافت معلومات از واتساپ، این پروسه ممکن است کمی وقت‌گیر باشد.',
      ConnectionTitle: 'برای وصل شدن، کد زیر را اسکن کنید.',
      ScanQrTitle:
        'بعد از اسکن QR Code، کاربر آریانا را از دستگاه‌های متصل خارج نکنید.',
      ScanQrAlert:
        'فرایند اسکن و وصل شدن به واتساپ تنها یک‌بار انجام می‌شود و در تمامی معاملات تطبیق می‌گردد.',
      'freeSolo.senderName': 'نام کامل فرستنده',
      'freeSolo.paymentPlace': 'محل پرداخت',
      'Fingerprint registered successfully': 'نشان انگشت با موفقیت ثبت گردید',
      RepeatOperation: 'تکرار عملیات',
      'Accept And Register': 'تایید و ثبت',
      UseDesktopVersionTitle:
        'جهت فعال کردن این امکان، از نسخه دسکتاپ نرم‌افزار استفاده کنید.',
      TransferBetweenTwoAccounts: 'انتقال بین حساب',
      CashTransaction: 'معامله نقدی',
      Miscellaneous: 'متفرقه',
      BuySellCurrency: 'تبادله اسعار',
      BankTransaction: 'معامله بانکی',
      ExecuteDraft: 'اجرای حواله',
      Cheque: 'چک',
      InterBankTransaction: 'معامله بین بانکی',
      PaymentOrderReceipt: 'رسید دستور پرداخت',
      ChangeBranch: 'تبدیل نرخ',
      UnknownBankTransaction: 'معامله نامعلوم بانکی',
      AddNewAccount: 'افزودن حساب جدید',
      UpdateAccount: 'ویرایش حساب',
      DeleteAccount: 'حذف حساب',
      AddBank: 'افزودن بانک',
      UpdateBank: 'ویرایش بانک',
      DeleteBank: 'حذف بانک',
      AddCustomer: 'افزودن مشتری',
      UpdateCustomer: 'ویرایش مشتری',
      DeleteCustomer: 'حذف مشتری',
      AddCompany: 'افزودن شرکت',
      UpdateCompany: 'ویرایش شرکت',
      DeleteCompany: 'حذف شرکت',
      AddBranch: 'افزودن نمایندگی',
      UpdateBranch: 'ویرایش نمایندگی',
      DeleteBranch: 'حذف نمایندگی',
      AddCurrency: 'افزودن ارز',
      UpdateCurrency: 'ویرایش ارز',
      DeleteCurrency: 'حذف ارز',
      AddPayOrder: 'افزودن دستور پرداخت',
      UpdatePayOrder: 'ویرایش دستور پرداخت',
      DeletePayOrder: 'حذف دستور پرداخت',
      Checkout: 'تسویه',
      RemoveCheckout: 'حذف تسویه',
      PendDraft: 'حواله در انتظار',
      RemovePendDraft: 'حذف حواله در انتظار',
      IncreaseCredit: 'افزایش اعتبار',
      CancelDraft: 'لغو حواله',
      SavedToCustomerAccount: 'واگذار شده',
      HasReturned: 'برگشت خورده',
      CashedToMoney: 'پاس شده',
      SavedToCashDeskOrBankAccount: 'خوابانده شده',
      Normal: 'عادی',
      Telegram: 'تلگرام',
      Whatsapp: 'واتساپ',
      Other: 'سایر',
      Male: 'مرد',
      Female: 'زن',
      customer: 'مشتری',
      receiver: 'گیرنده',
      Passport: 'پاسپورت',
      'Physical Tezkire': 'تذکره کاغذی',
      'Electronic Tezkire': 'تذکره برقی',
      'National Card': 'کارت ملی',
      'Birth Certificate': 'کارت تولد',
      'Kimlik Card': 'کارت کیملیک',
      'Driving License': 'جواز رانندگی',
      Germany: 'آلمان',
      Sweden: 'سوئد',
      Norway: 'نروژ',
      Greece: 'یونان',
      Baghdad: 'بغداد',
      Ankara: 'آنکارا',
      'Saudi Arabia': 'عربستان سعودی',
      Tehran: 'تهران',
      'United Arab Emirates': 'امارات متحده عربی',
      Kabul: 'کابل',
      'Islamabad, Karachi': 'کراچی ,اسلام آباد',
      Australia: 'استرالیا',
      China: 'چین',
      'Moneyx Accounting Panel': 'صفحه حسابداری مانیکس',
      Accounts: 'حساب‌ها',
      'Archived Accounts': 'حساب‌های آرشیف‌شده',
      'Journal Entries': 'روزنامچه',
      'Bank Transaction': 'معاملات بانکی',
      'Banks List': 'فهرست بانک‌ها',
      Dashboard: 'داشبورد',
      Department: 'شعبه',
      'General Ledger': 'دفتر کل',
      'Branch Edition': 'ویرایش نمایندگی',
      'Branch Registration': 'ثبت نمایندگی',
      'Branches List': 'فهرست نمایندگی‌ها',
      'Cash Transaction': 'معاملات نقدی',
      'Cheques List': 'فهرست چک‌ها',
      Reports: 'گزارشات',
      Registration: 'ثبت',
      'Commissions Report': 'گزارش کمیشن ها',
      'Edit Company': 'ویرایش شرکت',
      'Company Registration': 'ثبت شرکت',
      'Currencies Management': 'مدیریت ارزها',
      'Customers List': 'فهرست مشتریان',
      profile: 'پروفایل',
      'System Management': 'مدیریت سیستم',
      'Operation of the day': 'عملیات روز',
      'Operation Of The Day': 'عملیات روز',
      'Debtor And Creditor List': 'فهرست باقی‌داران و طلبکاران',
      'Decrease Customer Credit': 'کاهش اعتبار مشتری',
      Drafts: 'حواله‌ها',
      'Draft Conduction': 'اجرای حواله',
      'Incoming Draft Submission': 'ثبت حواله آمد',
      'Miscellaneous Draft Submission': 'ثبت حواله متفرقه',
      'Outgoing Draft Submission': 'ثبت حواله رفت',
      'Draft Documents List': 'فهرست مدارک حواله',
      'Unrealized Drafts List': 'فهرست حواله‌های اجرا نشده',
      'Draft Orders List': 'فهرست سفارشات حواله',
      'Excel Data Output': 'خروجی اکسل اطلاعات',
      'Financial Operation': 'عملیات مالی',
      'Increase Customer Credit': 'افزایش اعتبار مشتری',
      'Interbank Transaction': 'معامله بین بانکی',
      'Organizations List': 'لیست سازمان‌ها',
      'Payment Order': 'دستور پرداخت',
      'Pending Transactions List': 'فهرست معامله های در انتظار',
      'Edit Person': 'ویرایش شخص',
      'Register Person': 'ثبت شخص',
      'Profit And Loss Statement': 'مفاد تخمینی',
      'Receivers List': 'فهرست گیرنده‌ها',
      'Bug Details': 'جزئیات خطا',
      'Reported Bugs': 'خطاهای گزارش شده',
      'System Accounts': 'حساب‌های سیستم',
      'System Guides': 'درباره سیستم',
      'Trade Currencies List': 'فهرست تبادله اسعار',
      'Transfer Between Accounts': 'انتقال بین حساب',
      'Unknown Bank Transactions': 'معاملات نامعلوم بانکی',
      'Bank Book': 'دفتر بانک',
      'Branch Account': 'حساب نمایندگی',
      'Customer Credit Account': 'حساب اعتبار مشتری',
      'My Tickets': 'تیکت‌های من',
      'Pending Drafts List': 'فهرست حواله‌های در انتظار',
      English: 'انگلیسی',
      'language.persian': 'فارسی',
      'Accounting Panel': 'صفحه حسابداری',
      Administrator: 'مدیر سیستم',
      'Submit Cash Transaction': 'ثبت معامله نقدی',
      'Submit Bank Transaction': 'ثبت معامله بانکی',
      'Credits Account': 'حساب اعتبارات',
      'Draft Submission': 'ثبت حواله',
      'Draft List': 'لیست حواله',
      Incoming: 'آمد',
      Outgoing: 'رفت',
      'Buy Currency': 'خرید ارز',
      'Sell Currency': 'فروش ارز',
      'Account Information': 'اطلاعات حساب',
      actionArchive: 'آرشیف کردن',
      Archived: 'آرشیف',
      AddAccount: 'حساب اضافه کن',
      unknownbankaccounts: 'معاملات نامعلوم بانکی',
      End: 'ختم',
      'Mirror Branch Account': 'حساب نمایندگی مقابل',
      MirrorBranchAccount: 'حساب نمایندگی مقابل',
      UnexecutedDraft: 'حواله‌های اجرا نشده',
      unexecuteddraft: 'حواله‌های اجرا نشده',
      'Mirror Branch Information': 'معلومات شعبهٔ نمایندگی مقابل',
      'Required field message': 'پرکردن این فیلد اجباری است',
      undestandAndDoNotShowAgain:
        'من مطالب بالا را مطالعه کردم، دیگر نشان نده.',
      Buy: 'خرید',
      noteCreatedSuccessfully: 'یادداشت با موفقیت ایجاد شد',
      DeleteNoteTitle: 'آیا مطمئن هستید که می‌خواهید این یادداشت را حذف کنید؟',
      noteEditedSuccessfully: 'یادداشت با موفقیت ویرایش شد.',
      Notes: 'یادداشت‌ها',
      select: 'انتخاب کنید',
      PersonProfile: 'پروفایل شخص',
      'Bank Transactions': 'معاملات بانکی',
      General: 'عمومی',
      Banking: 'بانکی',
      Cost: 'مصرف'
    },
    dir: 'rtl'
  },
  fap: {
    translation: {
      TurkeyPhoneNumberValidation:
        'د ترکیې د ټیلیفون شمیره باید ۱۱ عدده وي او د 05 سره پیل شي.',
      'invalid number': 'د ټیلیفون شمیره ناسمه ده.',
      AfghanPhoneNumberValidation:
        'د افغانستان تلیفون شمیره باید ۱۰ رقمه وي او د ۰۷ سره پیل شي',
      'PhoneNumber must be 11 digits and start with 0':
        'شماره تلفن ایران باید ۱۱ رقمی باشد و با ۰۹ شروع شود',
      uploadFileWithTouch: 'د فایل اپلوډ کولو لپاره ټچ وکړئ.',
      'Drop Your Desired File Here': 'خپل مطلوب فایل دلته راوغورځوئ',
      Or: 'یا',
      Choose: 'انتخاب کړئ',
      UseWebcam: 'ویبکام وکاروئ (CTRL + k)',
      uploaderInputLabelMaximumSize: 'د فایل اندازه باید اعظمي ۳ میګابایټه وي',
      And: 'او',
      FileUploaderInputLabelFormat:
        'فایل باید د xls, xlsx, pdf, png, jpg, jpeg, doc, docx, webp فارمیټونو څخه وي',
      TakePicture: 'عکس اخیستل',
      CustomerBasicInformation: 'د مشتری بنسټیز معلومات',
      "Please enter the customer's full name. This step is required":
        'لطفاً نام و تخلص مشتری را وارد کنید. این مرحله الزامی است.',
      'Advanced Details': 'پرمختللي معلومات',
      'You can optionally enter additional customer information here. This step is not mandatory':
        'در این قسمت میتوانید معلومات اضافی مشتری را بنویسید. این بخش الزامی نیست.',
      'Phone Number': 'د تلیفون شمېره',
      "First, enter the country code, then enter the customer's phone number without the leading zero":
        'لطفاً ابتدا کد کشور را وارد کنید و سپس شماره مشتری را بدون صفر اول وارد نمایید.',
      MaknakUsername: 'د مکنک کارونکي نوم',
      Maknak: 'مکنک',
      "The Maknak username is used to activate the customer's mobile app.":
        'این قسمت به طور خودکار از شماره موبایل مشتری پر می‌شود.',
      'customer account': 'د مشتری حساب',
      "This step is the most important part of the customer account. Here, you register the customer's remaining balance.":
        'در این مرحله حساب باقی‌مانده مشتری را وارد کنید.',
      'tutorial.dateFeature': 'فیچر تاریخ',
      'tutorial.dateFeatureContent':
        'این فیچر به شما امکان تغییر تاریخ تراکنش را میدهد',
      'tutorial.accountStatus': 'وضعیت حساب',
      'tutorial.accountStatusContent':
        'در این بخش وضعیت حساب انتخاب شده را میتوانید مشاهده بکنید.',
      'tutorial.selectGroup': 'انتخاب گروه',
      'tutorial.selectGroupContent':
        'در این بخش برای هر تراکنش میتوانید گروه مربوطه را انتخاب کنید.',
      'tutorial.description': 'توضیحات',
      'tutorial.descriptionContent':
        'در این بخش میتوانید توضیحات مربوط به تراکنش را وارد کنید.',
      Back: 'بازگشت',
      'voiceRecorder.stopRecording': 'توقف ضبط',
      'voiceRecorder.recording': 'درحال ضبط...',
      'voiceRecorder.delete': 'حذف',
      'Important Notice': 'مهم خبرتیا',
      'I Understand': 'زه پوهیږم',
      'System Account': 'د سیستم حساب',
      'Operation Type': 'د عملیات ډول',
      Comma: '،',
      'Account Title': 'د حساب عنوان',
      'Account Number': 'د حساب شمېره',
      'Credit Limit': 'د کریډیټ حد',
      UncertainCreditLimit:
        'که کریډیټ حد نه وي ټاکل شوی، صفر په پام کې نیول کیږي',
      Unlimited: 'لامحدود',
      Add: 'اضافه کول',
      HasAccountInitialBalance: 'آیا حساب ابتدائیه موجودی لري؟',
      'No Option Message': 'هیڅ اختیار شتون نلري',
      'Upload a logo for the header': 'لوګو د سرلیک لپاره اپلوډ کړئ',
      HeaderUploaderTitle: 'د سرلیک انځور اوږدوالی او پلنوالی باید یو شان وي.',
      ViewHeader: 'سرلیک وګورئ',
      'Transaction Type': 'د تراکنش ډول',
      AllBranches: 'ټولې څانګې',
      DepartmentsList: 'د څانګو لیست',
      Group: 'ډله',
      All: 'ټول',
      Groups: 'ډلې',
      AllCashDesks: 'همه صندوق‌ها',
      Weak: 'ضعیف',
      Medium: 'منځنی',
      Good: 'ښه',
      Excellent: 'ممتاز',
      AllOptions: 'ټول انتخابونه',
      'Communication Way': 'د اړیکو طریقه',
      Cancel: 'لغوه کول',
      AllCurrencies: 'ټول اسعار',
      currency: 'اسعار',
      Account: 'حساب',
      Bank: 'بانک',
      'Bank Information': 'د بانک معلومات',
      Clear: 'پاکول',
      OK: 'هو',
      Delete: 'حذف کړئ',
      Description: 'تشریح',
      'Document Type': 'د سند ډول',
      AllEmployees: 'ټول کارمندان',
      'no attachments': 'هیڅ ضمیمه نشته',
      'File size exceeds limit':
        'د فایل اندازه {{fileName}} له اجازه ورکړل شوي حد څخه زیاته ده.',
      'File with name already exists':
        'فایل د {{fileName}} نوم سره دمخه شتون لري.',
      'Connected With Data': 'له ډیټا سره تړلی',
      'Connected Without Data': 'بیا هڅه وکړئ (کاریال نه دی روان)',
      'Retry (Application Is Not Running)': 'بې هڅه وکړئ (کاریال نه دی روان)',
      Gender: 'جنس',
      Colon: ':',
      Deposit: 'جمع کول',
      Withdraw: 'بیرته اخیستل',
      'In progress': 'په جریان کې',
      'No Content Message': 'هیڅ محتوا شتون نلري',
      NotActiveSystemError: 'سیستم ستاسو لپاره فعال نه دی!',
      ExpiredSubscriptionError: 'ستاسو د ګډون موده پای ته رسیدلې ده!',
      SubscriptionTimeUntilDate: 'ستاسې د ګډون وخت تر نیټې پورې',
      HasBeen: 'شوی دی',
      ReActiveAccountTitle: 'د بیا فعالولو لپاره، د نسخه اخیستلو تڼۍ فشار کړئ.',
      ConnectedBranches: 'وصل شوي څانګې',
      BuyVersion: 'د نسخې پیرود',
      buyVersionTitle: 'د آریانا سیستم کارولو لپاره، لومړی نسخه واخلئ.',
      BalanceAmount: 'د موجودي اندازه',
      Debtor: 'پورمن',
      Creditor: 'طلبکار',
      SyncBalanceAndCreditLimit: 'موجودي له اعتبار حد سره همغږي کړئ',
      Inventory: 'ذخیره',
      Percent: 'سلنه',
      '0to50ValidPercentage': 'د معتبره پیژندل شوی مقدار ۰ څخه ۵۰ پرکې',
      'form.organization': 'سازمان',
      Dollar: 'ډالر',
      Equal: 'برابر',
      DollarRate: 'د ډالر نرخ',
      CalculationType: 'د محاسبې ډول',
      Division: 'تقسیم',
      Multiplication: 'ضرب',
      Prepayments: 'مخکې ورکړې',
      AdvancePurchaseContracts: 'د مخکې پیرلو قراردادونه',
      Assets: 'شتمونه',
      TangibleAssets: 'ملموسه شتمنۍ',
      ReductionInTangibleAssets: 'د ملموس شتمنیو د استهلاکاتو کمښت',
      IntangibleAssets: 'غیر ملموسه شتمنۍ',
      DepreciationOfIntangibleAssets: 'د غیر ملموس شتمنیو کمښت',
      PayableBills: 'د تادیې وړ بلونه',
      PayableTaxes: 'د ورکړې وړ مالیات',
      AdvanceSalesContracts: 'د مخکې پلورلو قراردادونه',
      AdministrativeExpenses: 'اداري لګښتونه',
      TelephoneAndCommunicationExpenses: 'د تلیفون او مخابراتي لګښتونه',
      RentExpenses: 'د کرایې لګښتونه',
      Insurance: 'بیمه',
      Partners: 'شریکان',
      LicensingExpenses: 'د جواز اخستلو لګښتونه',
      EmployeeSalaries: 'د کارمندانو معاشونه',
      ClaimsOnCentralBank: 'د افغانستان بانک غوښتنې',
      SelectRowAlert: 'لومړی یو ردیف انتخاب کړئ.',
      'Due to the long number of letters of the selected document information, it is not possible to share.':
        'د انتخاب شوي سند د معلوماتو اوږدو حروفو له امله، د شراکت امکان نشته.',
      Manual: 'لاسي',
      'Document Prime': 'اصلي سند',
      IssuingOrganization: 'صادرونکی ارګان',
      Show: 'ښکاره کړئ',
      'Currency Type': 'د اسعارو ډول',
      'From Date': 'له نېټې څخه',
      TimeZone: 'وخت زون',
      'Click to log out of WhatsApp': 'د واتس‌اپ څخه وتلو لپاره کلیک وکړئ',
      'Click to log in to WhatsApp': 'د واتس‌اپ ته لاګین لپاره کلیک وکړئ',
      LogOutConfirmation:
        'ایا تاسو ډاډه یاست چې غواړئ د خپل واټساپ حساب څخه ووځئ؟',
      'Log Out': 'وتل',
      Return: 'بېرته راستنېدل',
      PreventZoomModalTitle: 'د د خط د کچې بدلولو لپاره، لاندې بکس وکاروئ.',
      FontSize: 'د فونټ اندازه',
      large: 'لوی',
      medium: 'منځنی',
      small: 'کوچنی',
      Submit: 'تایید',
      IncomingDraft: 'وارد شوی حواله',
      OutgoingDraft: 'صادر شوی حواله',
      'Draft Number': 'د حوالې شمېره',
      'Other Number': 'بله شمېره',
      Sender: 'لېږدونکی',
      Receiver: 'ترلاسه کونکی',
      'Draft Amount': 'د حوالې اندازه',
      Commission: 'کمیشن',
      'Payment Place': 'د تادیې ځای',
      Exchange: 'صرافی',
      Draft: 'حواله',
      'Transaction Description': 'د معاملې تشریح',
      RemainingAccount: 'د حساب پاتې',
      Status: 'حالت',
      BranchAddress: 'د څانګې پته',
      BranchPhone: 'د څانګې ټلیفون',
      'Cash withdrawal': 'نغدي پیسې اخیستل',
      'Cash deposit': 'نغدي پیسې جمع کړئ',
      To: 'تر',
      From: 'له',
      Balance: 'باقي اندازه',
      'Trade Currency': 'د اسعارو تجارت',
      Seller: 'پلورونکی',
      'Sell Amount': 'د پلور اندازه',
      Buyer: 'پېرودونکی',
      'Buy Amount': 'د پېر اندازه',
      Rate: 'نرخ',
      BankWithdraw: 'د بانک ایستنه',
      BankDeposit: 'د بانک واریز',
      'Bank Name': 'د بانک نوم',
      amount: 'اندازه',
      'transfer between accounts': 'انتقال تر منځ حسابونه',
      'Transaction Amount': 'د معاملې اندازه',
      'Account Remaining': 'د حساب پاتې اندازه',
      Date: 'نېټه',
      'Customer Name': 'د مشتری نوم',
      AmountAccountWhatsappReport:
        'دلته ستاسو د حساب موجودي داسې ښودل شوی دی :',
      BranchName: 'د نمایندګۍ نوم',
      Remaining: 'پاتې',
      New: 'نوې',
      'Under Review': 'تر بیاکتنې لاندې',
      Failed: 'ناکام شوی',
      Done: 'ترسره شو',
      'transactionType.buy': 'خرید',
      'transactionType.sell': 'فروش',
      Received: 'ترلاسه شوی',
      Paid: 'تادیه شوی',
      to: 'ته',
      'Account Balance': 'د حساب پاتې اندازه',
      'Sample Balance': '5/435/000',
      'Sample Balance Currency': 'تومان',
      dir: 'rtl',
      'Your Credit': 'ستاسې کریډیټ',
      Languages: 'ژبې',
      Messages: 'پیغامونه',
      'Mirror Branch': 'مقابل څانګه',
      Notifications: 'اعلانونه',
      'Quick Access': 'چټک لاسرسی',
      Pages: 'مخونه',
      'System Settings': 'د سیستم ترتیبات',
      UserAccountSystem: 'کارونکي حساب سیسټم',
      AccountingSystem: 'محاسبې سیسټم',
      CurrencyAuction: 'د اسعارو لیلام',
      SanctionList: 'د تعزیراتو لیست پلي کول',
      'Central analysis of trades and financial reports':
        'د سوداګریو او مالي راپورونو مرکزي تحلیل',
      'Exchange license validation': 'د جواز اعتبار تایید',
      'Organization Chart': 'د سازمان چارټ',
      ExitFromSystem: 'له سیسټم څخه ووتل',
      'newFeatures.title': 'امکانات جدید',
      'newFeatures.excelExport': 'دریافت کل اطلاعات در قالب فایل اکسل',
      'newFeatures.excelExportDescription':
        'هم اکنون میتوانید از بخش گزارشات و در صفحه خروجی اکسل اطلاعات تمامی اطلاعات خودرا در قالب فایل اکسل دانلود نمایید.',
      'newFeatures.excelCustomerRegistration': 'ثبت مشتری با فایل اکسل',
      'newFeatures.excelCustomerRegistrationDescription':
        'هم اکنون کاربران میتوانند با آپلود فایل اکسل خود که لیستی از چندین مشتری هست در قسمت لیست مشتریان و بخش ورود اطلاعات بصورت همزمان چند مشتری را ثبت نمودهو به لیست مشتریان خود اضافه کنند.',
      'newFeatures.priceToText': 'تبدیل و نمایش همزمان قیمت وارد شده به حروف',
      'newFeatures.priceToTextDescription':
        'شما میتوانید در صفحه اجرای حواله ؛ گیرنده حواله نامعلوم خود را از بین گیرندگان انتخاب کنید یا به صورت دستی شخص گیرنده را تعیین کنید.',
      'newFeatures.ticketShortcuts': 'shortcut های ثبت تیکت',
      'newFeatures.ticketShortcutsDescription':
        'درحال حاضر در هنگام ثبت تیکت با استفاده از Shift+Enter  درهنگام تایپ به خط بعد میروید و با Enter تیکت خودرا ثبت میکنید.',
      SystemNewFeatures: 'د سیسټم نوې ځانګړتیاوې',
      Close: 'بندول',
      Next: 'بل',
      'Add Ticket': 'ټکټ ثبت کړئ',
      SubmitBugReportSuccessfully:
        'د خطا راپور په بریالیتوب سره ثبت شو او په نږدې وخت کې ځواب ورکړل شي.',
      TicketTitle: 'د ټکټ سرلیک',
      GetScreenShout: 'له صفحې څخه سکرین شاټ واخلئ',
      AddFile: 'که اړتیا وي فایل اضافه کړئ.',
      OrderDetails: 'د پیرودلو جزئیات',
      'Mobile Number': 'د موبایل شمېره',
      Operator: 'اپریټر',
      package: 'بسته',
      'Select or enter Charge amount': 'د چارج اندازه دننه یا وټاکئ',
      chargeAmount: 'د چارج مقدار',
      Accept: 'قبول کړئ',
      Continue: 'ادامه',
      'Date And Time': 'نېټه او وخت',
      PaymentAmount: 'د تادیې مقدار',
      trackingNumber: 'د تعقیب شمېره',
      orderStatusMessage:
        'ستاسې فرمایش ثبت شوی او ډېر ژر به اجرا شي. تاسې کولای شئ د هغې وضعیت د تراکنشونو په برخه کې تعقیب کړئ.',
      'Visit Transactions': 'د تراکنشون لیدلنه',
      InProgress: 'په جریان کې',
      BePatient: 'صبر وکړئ',
      'No Submited Transaction': 'هیڅ معامله ثبت نه ده',
      PubgId: 'د پبجي ایډي',
      LikeeId: 'د لایکي ایډي',
      SelectDesirePackage: 'خپله خوښه بسته انتخاب کړئ',
      MaknakApp: 'د مکنک اپلیکیشن',
      'buy charge': 'د پیرود چارج',
      'buy internet': 'د انټرنټ پېرودنه',
      buySnap: 'د اسنپ حساب چارج کول',
      barghararCharge: 'د برقرار حساب چارج کول',
      Bargharar: 'برقرار',
      'Bargharar Services': 'د برقرار خدمتونه',
      'Buy Package': 'د بسته پېرودنه',
      'Wallet Charge': 'د کیف پول چارج کول',
      'Check Number Exists': 'د شمېرې موجودیت وګورئ',
      'User does not exist': 'کاربر موجود نیست',
      Amount: 'مبلغ',
      imoCharge: 'د ایمو حساب چارج کول',
      pubgCharge: 'د پبجي حساب چارج کول',
      Services: 'خدمتونه',
      Transactions: 'تراکنشونه',
      SelectAccountTitle: 'مهرباني وکړئ لومړی خپل غوښتل شوی حساب وټاکئ',
      Links: 'لینکونه',
      Moneyx: 'مانیکس',
      Credit: 'کریډیټ',
      night: 'شپه',
      day: 'ورخ',
      'Sign Out': 'وتل',
      Update: 'تازه کول',
      'New Version Available Phrase':
        'د سیستم نوې نسخه موجوده ده؛ لطفاً پاڼه تازه کړئ',
      'Sample Person': 'د بېلګې شخص',
      ErrorPage: 'د خطا صفحه',
      'utils.accountCode': 'کد حساب',
      'utils.name': 'نام',
      'utils.lastName': 'نام خانوادگی',
      'utils.phoneNumber': 'شماره تلفن',
      'utils.countryCode': 'کد کشور',
      'utils.inputAmount': 'مبلغ ورودی',
      'utils.currencyNotIncluded':
        'ارز "{{currencyCode}}" در ردیف {{rowNumber}} جزو ارزهای شما نیست',
      'utils.debtorCreditor': 'بدهکار/طلبکار',
      'utils.gender': 'جنسیت',
      'utils.firstRowEmpty': 'ردیف اول نمیتواند خالی باشد',
      'utils.lastRowNotFound': 'ردیف آخر شناسایی نشد',
      'utils.rowsWithSameAccountDifferentName':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در نام دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountDifferentLastName':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در نام خانوادگی دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountDifferentFatherName':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در نام پدر دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountDifferentPhone':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در شماره تلفن دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountSameCurrency':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در کد ارز دارای مقادیر یکسان باشند.',
      'utils.rowsWithSameAccountDifferentCountry':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در کد کشور دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountDifferentGender':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در جنسیت دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountDifferentGroup':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در گروه دارای مقادیر متفاوت باشند.',
      'utils.rowsWithSameAccountDifferentCategory':
        'سطرهایی با شماره حساب {{accountTitle}} نمیتوانند در دسته بندی دارای مقادیر متفاوت باشند.',
      'utils.differentAccountsSamePhone':
        'سطرهایی با شماره حساب متفاوت {{account1}} و {{account2}} نمیتوانند دارای شماره تلفن یکسان باشند',
      'utils.currencyAmountDebtorCreditorRequired':
        'در هر ردیف، ارز-مبلغ-طلبکار/بدهکار یا همگی باید پر باشند یا همگی خالی باشند.',
      'utils.phoneCountryCodeRequired':
        'در هر ردیف، شماره تلفن و کد کشور یا همگی باید پر باشند یا همگی خالی باشند.',
      'utils.invalidValueInRow':
        'مقدار "{{cellError}}" در ردیف "{{rowNumber}}" برای ستون "{{columnValue}}" یک مقدار غیرقابل قبول هست.',
      'utils.accountCannotHaveDifferentValues':
        'کد حساب {{accountNumber}} نمیتواند دارای مقادیر متفاوتی در {{columnTitle}} باشد',
      'table.calculate': 'محاسبه {{column}}',
      'table.column': 'ستون',
      'table.rowCount': 'تعداد ردیف',
      'table.minimum': 'کمینه',
      'table.maximum': 'بیشینه',
      'table.sum': 'مجموع',
      'table.average': 'میانگین',
      CalculationBalance: 'د باقی محاسبه روانه ده',
      Known: 'مالوم',
      Unknown: 'ناڅرګند ',
      'bankTransaction.selectBankFirst': 'ابتدا بانک مورد نظر را انتخاب کنید.',
      SelectDocument: 'انتخاب سند',
      TransactionBeWithoutDescription: 'معامله دې پرته له توضیحاتو وي',
      SyncCreditLimit: 'د کریډیټ حد همغږي کړئ',
      PublishTransactionInWhatsapp: 'ډیفالټ معامله اعلان',
      'Trade Rate': 'د تبادلې نرخ',
      positiveTradeRate: 'د تبادلې نرخ باید له صفر څخه زیات وي.',
      invalidTradeRate: 'د تبادلې نرخ معتبر نه دی',
      TheWayOfTransaction: 'د لیږد طریقه',
      BaseOnAmount: 'د مقدار پر اساس',
      BaseOnRate: 'د نرخ پر اساس',
      SelectItemToAutoCalculate: 'کوم آیتم په اوتومات ډول محاسبه شي؟',
      'triplex.sellAmount': 'مبلغ فروش',
      'triplex.buyAmount': 'مبلغ خرید',
      'triplex.conversionRate': 'نرخ تبدیل',
      'Calculating Profit and Loss': 'ګټه او زیان محاسبه',
      'System Rate': 'د سیستم نرخ',
      bankStatusMessage2: 'له بانک انتخاب وروسته، د بانک حساب موجودي ښودل کېږي',
      BankAccountBalance: 'د بانک حساب پاتې شوې اندازه',
      Deposit2: 'جمع کول',
      Withdraw2: 'بیرته اخیستل',
      'bankTransaction.document': 'سند {{transactionType}}',
      PaymentType: 'د تادیې ډول',
      'bankTransaction.oldTransaction': '{{transactionType}} قدیم',
      'bankTransaction.transactionDate': 'تاریخ تراکنش',
      'Transaction Number': 'د تراکنش شمېره',
      Branch: 'څانګه',
      Settings: 'ترتیبات',
      'creditAccount.balance': 'مانده حساب اعتبار',
      AccountStatusMessage:
        'د حساب او ارز انتخاب وروسته، د حساب موجودي ښودل کېږي.',
      CustomerAccountRemaining: 'د مشتری حساب پاتې',
      'draggableList.paymentPlace': 'محل پرداخت',
      Edit: 'ویرایش',
      'draggableList.delete': 'حذف',
      AddPaymentPlace: 'د پیسو ځای اضافه کړئ',
      Enable: 'فعال کړئ',
      Webcam: 'ویبکام',
      'Upload File': 'فایل اپلوډ کړئ',
      NoBalanceIsThere: 'هیڅ موجودي ثبت نه ده',
      'previewImages.viewDocuments': 'مشاهده مدارک',
      'providerService.selectOrganizationFirst':
        'پس از انتخاب سازمان، مانده حساب سازمان به تفکیک نمایش داده می‌شود.',
      'providerService.organizationBalance': 'مانده حساب سازمان',
      Search: 'لټون',
      ShowLess: 'کم ښکاره کړئ',
      ShowMore: 'نور ښکاره کړئ',
      'switchableWhatsapp.noNotification': 'تراکنش در واتساپ اعلان نمیشه',
      'updateNotification.systemUpdate':
        'سامانه در تاریخ {{date}} از ساعت {{startTime}} الی {{endTime}} در حال به روزرسانی خواهد بود.',
      'Activating WhatsApp': 'د واتساپ فعالول',
      WhitsappTitle:
        'له واتساپ څخه د معلوماتو ترلاسه کول، دا به یو څه وخت ونیسي.',
      ConnectionTitle: 'د نښلولو لپاره، لاندې کود سکین کړئ.',
      ScanQrTitle:
        'له QR کود سکین کولو وروسته، کارن آریانا له وصل شویو وسیلو مه وباسئ.',
      ScanQrAlert:
        'د واتساپ سره د سکین او نښلولو پروسه یوازې یو ځل ترسره کیږي او په ټولو معاملاتو کې پلي کیږي.',
      'freeSolo.senderName': 'نام و نام خانوادگی فرستنده',
      'freeSolo.paymentPlace': 'محل پرداخت',
      'Fingerprint registered successfully':
        'د ګوتې نښه په بریالیتوب سره ثبت شوه',
      RepeatOperation: 'عملیات تکرار کړئ',
      'Accept And Register': 'قبول او ثبت کړئ',
      UseDesktopVersionTitle:
        'د دې ځانګړتیا فعالولو لپاره، د سیستم ډیسکتاپ نسخه وکاروئ.',
      TransferBetweenTwoAccounts: 'انتقال تر منځ دوه حسابونه',
      CashTransaction: 'نقدي معامله',
      Miscellaneous: 'متفرقه',
      BuySellCurrency: 'اسعار اخیستل او پلورل',
      BankTransaction: 'بانکي معامله',
      ExecuteDraft: 'حواله اجرا کړئ',
      Cheque: 'چک',
      InterBankTransaction: 'بین بانکي معامله',
      PaymentOrderReceipt: 'د تادیې فرمایش رسید',
      ChangeBranch: 'د نرخ تبدیلول',
      UnknownBankTransaction: 'نامعلومه بانکي معامله',
      AddNewAccount: 'نوی حساب اضافه کړئ',
      UpdateAccount: 'حساب ویرایش کړئ',
      DeleteAccount: 'حساب حذف کړئ',
      AddBank: 'بانک اضافه کړئ',
      UpdateBank: 'بانک ویرایش کړئ',
      DeleteBank: 'بانک حذف کړئ',
      AddCustomer: 'مشتری اضافه کړئ',
      UpdateCustomer: 'مشتری ویرایش کړئ',
      DeleteCustomer: 'مشتری حذف کړئ',
      AddCompany: 'شرکت اضافه کړئ',
      UpdateCompany: 'شرکت ویرایش کړئ',
      DeleteCompany: 'شرکت حذف کړئ',
      AddBranch: 'نمایندګي اضافه کړئ',
      UpdateBranch: 'نمایندګي ویرایش کړئ',
      DeleteBranch: 'نمایندګي حذف کړئ',
      AddCurrency: 'اسعار اضافه کړئ',
      UpdateCurrency: 'اسعار ویرایش کړئ',
      DeleteCurrency: 'اسعار حذف کړئ',
      AddPayOrder: 'د تادیې فرمایش اضافه کړئ',
      UpdatePayOrder: 'د تادیې فرمایش ویرایش کړئ',
      DeletePayOrder: 'د تادیې فرمایش حذف کړئ',
      Checkout: 'تسویه',
      RemoveCheckout: 'تسویه لرې کړئ',
      PendDraft: 'په انتظار حواله',
      RemovePendDraft: 'په انتظار حواله حذف کړئ',
      IncreaseCredit: 'د کریډیټ زیاتوالی',
      CancelDraft: 'حواله لغوه کړئ',
      SavedToCustomerAccount: 'مشتری ته وسپارل شو',
      HasReturned: 'بېرته راستون شوی',
      CashedToMoney: 'نغد شوی',
      SavedToCashDeskOrBankAccount: 'په نغدي صندوق یا بانک کې ثبت شوی',
      Normal: 'عادي',
      Telegram: 'تلګرام',
      Whatsapp: 'واتساپ',
      Other: 'نور',
      Male: 'نارینه',
      Female: 'ښځه',
      customer: 'مشتری',
      receiver: 'ترلاسه کونکی',
      Passport: 'پاسپورټ',
      'Physical Tezkire': 'فزیکي تذکره',
      'Electronic Tezkire': 'برقي تذکره',
      'National Card': 'ملي کارت',
      'Birth Certificate': 'د زیږون سند',
      'Kimlik Card': 'د کیملیک کارت',
      'Driving License': 'د موټر چلولو جواز',
      Germany: 'المان',
      Sweden: 'سویډن',
      Norway: 'ناروې',
      Greece: 'یونان',
      Baghdad: 'بغداد',
      Ankara: 'انقره',
      'Saudi Arabia': 'سعودي عربستان',
      Tehran: 'تهران',
      'United Arab Emirates': 'متحده عربي امارات',
      Kabul: 'کابل',
      'Islamabad, Karachi': 'اسلام آباد، کراچۍ',
      Australia: 'آسټرالیا',
      China: 'چین',
      'Moneyx Accounting Panel': 'د مانیکس حسابدارۍ پینل',
      Accounts: 'حسابونه',
      'Archived Accounts': 'آرشیف شوي حسابونه',
      'Journal Entries': 'ژورنال داخلونه',
      'Bank Transaction': 'بانکي معامله',
      'Banks List': 'د بانکونو لیست',
      Dashboard: 'ډشبورډ',
      Department: 'څانګه',
      'General Ledger': 'عمومي کتاب',
      'Branch Edition': 'څانګه ویرایش کړئ',
      'Branch Registration': 'څانګه ثبت کړئ',
      'Branches List': 'د څانګو لیست',
      'Cash Transaction': 'نقدي معامله',
      'Cheques List': 'د چکونو لیست',
      Reports: 'راپورونه',
      Registration: 'ثبت',
      'Commissions Report': 'د کمیشن راپور',
      'Edit Company': 'شرکت ویرایش کړئ',
      'Company Registration': 'شرکت ثبت کړئ',
      'Currencies Management': 'د اسعارو مدیریت',
      'Customers List': 'د مشتریانو لیست',
      profile: 'پروفایل',
      'System Management': 'د سیستم مدیریت',
      'Operation of the day': 'د ورځې عملیات',
      'Operation Of The Day': 'د ورځې عملیات',
      'Debtor And Creditor List': 'د پورمن او طلبکار لیست',
      'Decrease Customer Credit': 'د مشتری کریډیټ کم کړئ',
      Drafts: 'حوالې',
      'Draft Conduction': 'د حوالې اجرا',
      'Incoming Draft Submission': 'د وارد شوي حوالې ثبت',
      'Miscellaneous Draft Submission': 'متفرقه حواله ثبت',
      'Outgoing Draft Submission': 'د صادر شوي حوالې ثبت',
      'Draft Documents List': 'د حوالو اسنادو لیست',
      'Unrealized Drafts List': 'نا اجرا شوی حوالو لیست',
      'Draft Orders List': 'د حوالې فرمایشونو لیست',
      'Excel Data Output': 'د ایکسل معلوماتو آوټپټ',
      'Financial Operation': 'مالي عملیات',
      'Increase Customer Credit': 'د مشتری کریډیټ زیات کړئ',
      'Interbank Transaction': 'بین بانکي معامله',
      'Organizations List': 'د سازمانونو لیست',
      'Payment Order': 'د تادیې فرمایش',
      'Pending Transactions List': 'د انتظار معاملو لیست',
      'Edit Person': 'شخص ویرایش کړئ',
      'Register Person': 'شخص ثبت کړئ',
      'Profit And Loss Statement': 'د ګټې او زیان راپور',
      'Receivers List': 'د ترلاسه کونکو لیست',
      'Bug Details': 'د نیمګړتیاوو جزئیات',
      'Reported Bugs': 'راپور شوي نیمګړبیافافباغقغغتیاوې',
      'System Accounts': 'سیستم حسابونه',
      'System Guides': 'د سیستم لارښوونې',
      'Trade Currencies List': 'د اسعارو تجارت لیست',
      'Transfer Between Accounts': 'تر منځ حسابونه لیږد',
      'Unknown Bank Transactions': 'نامعلوم بانکي معاملات',
      'Bank Book': 'د بانک کتاب',
      'Branch Account': 'د څانګې حساب',
      'Customer Credit Account': 'د مشتری اعتباري حساب',
      'My Tickets': 'زما ټکټونه',
      'Pending Drafts List': 'په انتظار حوالې',
      English: 'انګلیسي',
      'language.persian': 'فارسي',
      'Accounting Panel': 'د حسابدارۍ پینل',
      Administrator: 'مدیر',
      'Submit Cash Transaction': 'نقدي معامله ثبت کړئ',
      'Submit Bank Transaction': 'بانکي معامله ثبت کړئ',
      'Credits Account': 'د اعتباري حساب',
      'Draft Submission': 'حواله ثبت کړئ',
      'Draft List': 'د حوالې لیست',
      Incoming: 'وارد شوی',
      Outgoing: 'صادر شوی',
      'Buy Currency': 'د اسعارو پیرود',
      'Sell Currency': 'د اسعارو پلور',
      'Account Information': 'د حساب معلومات',
      actionArchive: 'ارشیف کول',
      Archived: 'ارشیف شوی',
      AddAccount: 'حساب ورزیږدول',
      unknownbankaccounts: 'نامعلوم بانکي حسابونه',
      End: 'پای',
      'Mirror Branch Account': 'د مقابل څانګې حساب',
      MirrorBranchAccount: 'د مقابل څانګې حساب',
      UnexecutedDraft: 'نا اجرا شوی حواله',
      unexecuteddraft: 'نا اجرا شوی حواله',
      'Mirror Branch Information': 'د هنداري څانګې معلومات',
      'Required field message': 'دا فیلډ ډکول اړین دي',
      undestandAndDoNotShowAgain: 'ما پورته مطالب ولوستل، بیا دې ښکاره نه کړي.',
      Buy: 'خریداری',
      noteCreatedSuccessfully: 'یادداشت په بریالیتوب جوړ شو.',
      DeleteNoteTitle: 'ایا ډاډه یاست چې غواړئ یادداشت حذف کړئ؟',
      noteEditedSuccessfully: 'یادښت په بریالیتوب سره سمون وموند.',
      Notes: 'یادښتونه',
      select: 'مهرباني وکړئ انتخاب وکړئ',
      PersonProfile: 'د شخص پروفایل',
      'Bank Transactions': 'بانکي معاملې',
      General: 'عمومي',
      Banking: 'بانکي',
      Cost: 'لګښت'
    },
    dir: 'rtl'
  }
};

export default frameworkTranslations;
